export const AuthActions = {
  THERAPIST_LOGIN_REQUEST: 'THERAPIST_LOGIN_REQUEST',
  THERAPIST_LOGIN_SUCCESS: 'THERAPIST_LOGIN_SUCCESS',
  THERAPIST_LOGIN_FAILURE: 'THERAPIST_LOGIN_FAILURE',
  THERAPIST_LOGIN_RESET: 'THERAPIST_LOGIN_RESET',
  THERAPIST_LOGOUT_REQUEST: 'THERAPIST_LOGOUT_REQUEST',
  THERAPIST_LOGOUT_SUCCESS: 'THERAPIST_LOGOUT_SUCCESS',
  THERAPIST_LOGOUT_FAILURE: 'THERAPIST_LOGOUT_FAILURE',
  THERAPIST_LOGOUT_RESET: 'THERAPIST_LOGOUT_RESET',
  REQUEST_SET_PASSWORD: 'REQUEST_SET_PASSWORD',
  SUCCESS_SET_PASSWORD: 'SUCCESS_SET_PASSWORD',
  FAILURE_SET_PASSWORD: 'FAILURE_SET_PASSWORD',
  RESET_SET_PASSWORD: 'RESET_SET_PASSWORD',
  TOKEN_FIRST_TIME: 'TOKEN_FIRST_TIME',

  AUTO_GENERATE_PASSWORD: 'AUTO_GENERATE_PASSWORD',
  AUTO_GENERATE_PASSWORD_SUCCESS: 'AUTO_GENERATE_PASSWORD_SUCCESS',
  AUTO_GENERATE_PASSWORD_FAILURE: 'AUTO_GENERATE_PASSWORD_FAILURE',
  AUTO_GENERATE_PASSWORD_RESET: 'AUTO_GENERATE_PASSWORD_RESET',
  AUTO_GENERATE_PASSWORD_LOADING: 'AUTO_GENERATE_PASSWORD_LOADING',

  POST_RESET_PASSWORD_REQUEST: 'POST_RESET_PASSWORD_REQUEST',
  POST_RESET_PASSWORD_SUCCESS: 'POST_RESET_PASSWORD_SUCCESS',
  POST_RESET_PASSWORD_FAILURE: 'POST_RESET_PASSWORD_FAILURE',
  POST_RESET_PASSWORD_RESET: 'POST_RESET_PASSWORD_RESET',
  POST_RESET_PASSWORD_LOADING: 'POST_RESET_PASSWORD_LOADING',
  THERAPIST_FACILITY_NOT_FOUND: 'THERAPIST_FACILITY_NOT_FOUND',
};

export const therapyPlanningAction = {
  GET_PLAN_OF_CARE_REQUEST: 'GET_PLAN_OF_CARE_REQUEST',
  GET_PLAN_OF_CARE_SUCCESS: 'GET_PLAN_OF_CARE_SUCCESS',
  GET_PLAN_OF_CARE_FAILURE: 'GET_PLAN_OF_CARE_FAILURE',
  GET_PLAN_OF_CARE_LOADING: 'GET_PLAN_OF_CARE_LOADING',

  CHECK_THERAPY_PLANNING_PLAN_MINUTES_REQUEST: 'CHECK_THERAPY_PLANNING_PLAN_MINUTES_REQUEST',
  CHECK_THERAPY_PLANNING_PLAN_MINUTES_SUCCESS: 'CHECK_THERAPY_PLANNING_PLAN_MINUTES_SUCCESS',
  CHECK_THERAPY_PLANNING_PLAN_MINUTES_FAILURE: 'CHECK_THERAPY_PLANNING_PLAN_MINUTES_FAILURE',
  CHECK_THERAPY_PLANNING_PLAN_MINUTES_RESET: 'CHECK_THERAPY_PLANNING_PLAN_MINUTES_RESET',
  CHECK_THERAPY_PLANNING_PLAN_MINUTES_LOADING: 'CHECK_THERAPY_PLANNING_PLAN_MINUTES_LOADING',

  GET_THERAPY_PLANNING_PATIENT_REQUEST: 'GET_THERAPY_PLANNING_PATIENT_REQUEST',
  GET_THERAPY_PLANNING_PATIENT_SUCCESS: 'GET_THERAPY_PLANNING_PATIENT_SUCCESS',
  GET_THERAPY_PLANNING_PATIENT_FAILURE: 'GET_THERAPY_PLANNING_PATIENT_FAILURE',

  GET_PATIENT_THERAPY_PLANNING_REQUEST: 'GET_PATIENT_THERAPY_PLANNING_REQUEST',
  GET_PATIENT_THERAPY_PLANNING_SUCCESS: 'GET_PATIENT_THERAPY_PLANNING_SUCCESS',
  GET_PATIENT_THERAPY_PLANNING_FAILURE: 'GET_PATIENT_THERAPY_PLANNING_FAILURE',
  GET_PATIENT_THERAPY_PLANNING_LOADING: 'GET_PATIENT_THERAPY_PLANNING_LOADING',
  GET_PATIENT_THERAPY_PLANNING_RESET: 'GET_PATIENT_THERAPY_PLANNING_RESET',

  GET_MDS_ASSESSMENT_REQUEST: 'GET_MDS_ASSESSMENT_REQUEST',
  GET_MDS_ASSESSMENT_SUCCESS: 'GET_MDS_ASSESSMENT_SUCCESS',
  GET_MDS_ASSESSMENT_FAILURE: 'GET_MDS_ASSESSMENT_FAILURE',
  GET_MDS_ASSESSMENT_LOADING: 'GET_MDS_ASSESSMENT_LOADING',
  CREATE_ASSESSMENT_REQUEST: 'CREATE_ASSESSMENT_REQUEST',
  CREATE_ASSESSMENT_SUCCESS: 'CREATE_ASSESSMENT_SUCCESS',
  CREATE_ASSESSMENT_FAILURE: 'CREATE_ASSESSMENT_FAILURE',
  CREATE_ASSESSMENT_LOADING: 'CREATE_ASSESSMENT_LOADING',
  RESET_CREATE_ASSESSMENT: 'RESET_CREATE_ASSESSMENT',
  UPDATE_ASSESSMENT_REQUEST: 'UPDATE_ASSESSMENT_REQUEST',
  UPDATE_ASSESSMENT_SUCCESS: 'UPDATE_ASSESSMENT_SUCCESS',
  UPDATE_ASSESSMENT_FAILURE: 'UPDATE_ASSESSMENT_FAILURE',
  RESET_UPDATE_ASSESMENT: 'RESET_UPDATE_ASSESSMENT',
  GET_ASSESSMENT_REQUEST: 'GET_ASSESSMENT_REQUEST',
  GET_ASSESSMENT_SUCCESS: 'GET_ASSESSMENT_SUCCESS',
  GET_ASSESSMENT_FAILURE: 'GET_ASSESSMENT_FAILURE',
  GET_ASSESSMENT_LOADING: 'GET_ASSESSMENT_LOADING',
  GET_THERAPY_PLANNING_REQUEST: 'GET_THERAPY_PLANNING_REQUEST',
  GET_THERAPY_PLANNING_SUCCESS: 'GET_THERAPY_PLANNING_SUCCESS',
  GET_THERAPY_PLANNING_CANCEL_TOKEN: 'GET_THERAPY_PLANNING_CANCEL_TOKEN',
  GET_THERAPY_PLANNING_FAILURE: 'GET_THERAPY_PLANNING_FAILURE',
  GET_THERAPY_PLANNING_LOADING: 'GET_THERAPY_PLANNING_LOADING',
  UPDATE_THERAPY_PLANNING_REQUEST: 'UPDATE_THERAPY_PLANNING_REQUEST',
  UPDATE_THERAPY_PLANNING_SUCCESS: 'UPDATE_THERAPY_PLANNING_SUCCESS',
  UPDATE_THERAPY_PLANNING_FAILURE: 'UPDATE_THERAPY_PLANNING_FAILURE',
  UPDATE_THERAPY_PLANNING_LOADING: 'UPDATE_THERAPY_PLANNING_LOADING',

  RESET_UPDATE_THERAPY_PLANNING_REQUEST: 'RESET_UPDATE_THERAPY_PLANNING_REQUEST',

  //authorization
  GET_CPT_CODE_BY_DISCIPLINE_REQUEST: 'GET_CPT_CODE_BY_DISCIPLINE_REQUEST',
  GET_CPT_CODE_BY_DISCIPLINE_SUCCESS: 'GET_CPT_CODE_BY_DISCIPLINE_SUCCESS',
  GET_CPT_CODE_BY_DISCIPLINE_FAILURE: 'GET_CPT_CODE_BY_DISCIPLINE_FAILURE',
  GET_CPT_CODE_BY_DISCIPLINE_LOADER: 'GET_CPT_CODE_BY_DISCIPLINE_LOADER',
  GET_CPT_CODE_BY_DISCIPLINE_RESET: 'GET_CPT_CODE_BY_DISCIPLINE_RESET',

  //edit authorization

  EDIT_AUTHORIZATION_PLANNING_REQUEST: 'EDIT_AUTHORIZATION_PLANNING_REQUEST',
  EDIT_AUTHORIZATION_PLANNING_SUCCESS: 'EDIT_AUTHORIZATION_PLANNING_SUCCESS',
  EDIT_AUTHORIZATION_PLANNING_FAILURE: 'EDIT_AUTHORIZATION_PLANNING_FAILURE',
  EDIT_AUTHORIZATION_PLANNING_LOADER: 'EDIT_AUTHORIZATION_PLANNING_LOADER',
  EDIT_AUTHORIZATION_PLANNING_RESET: 'EDIT_AUTHORIZATION_PLANNING_RESET',
  UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_REQUEST: 'UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_REQUEST',
  UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_SUCCESS: 'UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_SUCCESS',
  UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_FAILURE: 'UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_FAILURE',
  RESET_THERAPY_PLANNING_DISCHARGE_DATE_REQUEST: 'RESET_THERAPY_PLANNING_DISCHARGE_DATE_REQUEST',

  //get authorization details

  GET_AUTHORIZATION_DETAILS_REQUEST: 'GET_AUTHORIZATION_DETAILS_REQUEST',
  GET_AUTHORIZATION_DETAILS_SUCCESS: 'GET_AUTHORIZATION_DETAILS_SUCCESS',
  GET_AUTHORIZATION_DETAILS_FAILURE: 'GET_AUTHORIZATION_DETAILS_FAILURE',
  GET_AUTHORIZATION_DETAILS_LOADER: 'GET_AUTHORIZATION_DETAILS_LOADER',
  GET_AUTHORIZATION_DETAILS_RESET: 'GET_AUTHORIZATION_DETAILS_RESET',

  GET_CASE_MIX_GROUP_REQUEST: 'GET_CASE_MIX_GROUP_REQUEST',
  GET_CASE_MIX_GROUP_SUCCESS: 'GET_CASE_MIX_GROUP_SUCCESS',
  GET_CASE_MIX_GROUP_FAILURE: 'GET_CASE_MIX_GROUP_FAILURE',
  GET_CASE_MIX_GROUP_LOADING: 'GET_CASE_MIX_GROUP_LOADING',

  GET_CMG_RESOLUTION_REQUEST: 'GET_CMG_RESOLUTION_REQUEST',
  GET_CMG_RESOLUTION_SUCCESS: 'GET_CMG_RESOLUTION_SUCCESS',
  GET_CMG_RESOLUTION_FAILURE: 'GET_CMG_RESOLUTION_FAILURE',
  GET_CMG_RESOLUTION_LOADING: 'GET_CMG_RESOLUTION_LOADING',

  // Weekly CMG range verdict (LOW / HIGH / NORMAL) for one therapy week
  GET_CMG_STATUS_REQUEST: 'GET_CMG_STATUS_REQUEST',
  GET_CMG_STATUS_SUCCESS: 'GET_CMG_STATUS_SUCCESS',
  GET_CMG_STATUS_FAILURE: 'GET_CMG_STATUS_FAILURE',
  GET_CMG_STATUS_LOADING: 'GET_CMG_STATUS_LOADING',
  GET_CMG_STATUS_RESET: 'GET_CMG_STATUS_RESET',

  GET_PDPM_FEATURE_TOGGLE_REQUEST: 'GET_PDPM_FEATURE_TOGGLE_REQUEST',
  GET_PDPM_FEATURE_TOGGLE_SUCCESS: 'GET_PDPM_FEATURE_TOGGLE_SUCCESS',
  GET_PDPM_FEATURE_TOGGLE_FAILURE: 'GET_PDPM_FEATURE_TOGGLE_FAILURE',
  GET_PDPM_FEATURE_TOGGLE_LOADING: 'GET_PDPM_FEATURE_TOGGLE_LOADING',

  //get multiple MdS assessment
  GET_MULTIPLE_MDS_ASSESSMENT_SUCCESS: 'GET_MULTIPLE_MDS_ASSESSMENT_SUCCESS',
  GET_MULTIPLE_MDS_ASSESSMENT_FAILURE: 'GET_MULTIPLE_MDS_ASSESSMENT_FAILURE',
  GET_MULTIPLE_MDS_ASSESSMENT_LOADING: 'GET_MULTIPLE_MDS_ASSESSMENT_LOADING',
  GET_MULTIPLE_MDS_ASSESSMENT_REQUEST: 'GET_MULTIPLE_MDS_ASSESSMENT_REQUEST',
  GET_MULTIPLE_MDS_ASSESSMENT_RESET: 'GET_MULTIPLE_MDS_ASSESSMENT_RESET',

  // Verify PPS MDS assessment ARD against payer periods
  VERIFY_MDS_PPS_REQUEST: 'VERIFY_MDS_PPS_REQUEST',
  VERIFY_MDS_PPS_SUCCESS: 'VERIFY_MDS_PPS_SUCCESS',
  VERIFY_MDS_PPS_FAILURE: 'VERIFY_MDS_PPS_FAILURE',
  VERIFY_MDS_PPS_LOADING: 'VERIFY_MDS_PPS_LOADING',
  VERIFY_MDS_PPS_RESET: 'VERIFY_MDS_PPS_RESET',

  //mds assessment csv upload
  REQUEST_VALIDATE_MDS_CSV_TEMPLATE: 'REQUEST_VALIDATE_MDS_CSV_TEMPLATE',
  SUCCESS_VALIDATE_MDS_CSV_TEMPLATE: 'SUCCESS_VALIDATE_MDS_CSV_TEMPLATE',
  FAILURE_VALIDATE_MDS_CSV_TEMPLATE: 'FAILURE_VALIDATE_MDS_CSV_TEMPLATE',
  LOADING_VALIDATE_MDS_CSV_TEMPLATE: 'LOADING_VALIDATE_MDS_CSV_TEMPLATE',
  RESET_VALIDATE_MDS_CSV_TEMPLATE: 'RESET_VALIDATE_MDS_CSV_TEMPLATE',

  //mds csv template
  REQUEST_UPLOAD_MDS_CSV_TEMPLATE: 'REQUEST_UPLOAD_MDS_CSV_TEMPLATE',
  SUCCESS_UPLOAD_MDS_CSV_TEMPLATE: 'SUCCESS_UPLOAD_MDS_CSV_TEMPLATE',
  FAILURE_UPLOAD_MDS_CSV_TEMPLATE: 'FAILURE_UPLOAD_MDS_CSV_TEMPLATE',
  RESET_UPLOAD_MDS_CSV_TEMPLATE: 'RESET_UPLOAD_MDS_CSV_TEMPLATE',
  LOADING_UPLOAD_MDS_CSV_TEMPLATE: 'LOADING_UPLOAD_MDS_CSV_TEMPLATE',

  //therapy planning 2.0
  GET_PATIENT_THERAPY_PLANNING_REQUEST_2_0: 'GET_PATIENT_THERAPY_PLANNING_REQUEST_2_0',
  GET_PATIENT_THERAPY_PLANNING_SUCCESS_2_0: 'GET_PATIENT_THERAPY_PLANNING_SUCCESS_2_0',
  GET_PATIENT_THERAPY_PLANNING_FAILURE_2_0: 'GET_PATIENT_THERAPY_PLANNING_FAILURE_2_0',
  GET_PATIENT_THERAPY_PLANNING_LOADING_2_0: 'GET_PATIENT_THERAPY_PLANNING_LOADING_2_0',
  GET_PATIENT_THERAPY_PLANNING_RESET_2_0: 'GET_PATIENT_THERAPY_PLANNING_RESET_2_0',

  //get therapy planning 2.0
  GET_DATA_THERAPY_PLANNING_REQUEST_2_0: 'GET_DATA_THERAPY_PLANNING_REQUEST_2_0',
  GET_DATA_THERAPY_PLANNING_SUCCESS_2_0: 'GET_DATA_THERAPY_PLANNING_SUCCESS_2_0',
  GET_DATA_THERAPY_PLANNING_FAILURE_2_0: 'GET_DATA_THERAPY_PLANNING_FAILURE_2_0',
  GET_DATA_THERAPY_PLANNING_LOADING_2_0: 'GET_DATA_THERAPY_PLANNING_LOADING_2_0',
  GET_DATA_THERAPY_PLANNING_RESET_2_0: 'GET_DATA_THERAPY_PLANNING_RESET_2_0',
  ADD_SINGLE_THERAPY_PLANNING_2_0: 'ADD_SINGLE_THERAPY_PLANNING_2_0',

  //get therapy planning summary
  GET_THERAPY_PLANNING_SUMMARY_SUCCESS_2_0: 'GET_THERAPY_PLANNING_SUMMARY_SUCCESS_2_0',
  GET_THERAPY_PLANNING_SUMMARY_REQUEST_2_0: 'GET_THERAPY_PLANNING_SUMMARY_REQUEST_2_0',
  GET_THERAPY_PLANNING_SUMMARY_FAILURE_2_0: 'GET_THERAPY_PLANNING_SUMMARY_FAILURE_2_0',
  GET_THERAPY_PLANNING_SUMMARY_LOADING_2_0: 'GET_THERAPY_PLANNING_SUMMARY_LOADING_2_0',
  GET_THERAPY_PLANNING_SUMMARY_RESET_2_0: 'GET_THERAPY_PLANNING_SUMMARY_RESET_2_0',

  //edit single cell
  EDIT_SINGLE_CELL_THERAPY_PLANNING_REQUEST: 'EDIT_SINGLE_CELL_THERAPY_PLANNING_REQUEST',
  EDIT_SINGLE_CELL_THERAPY_PLANNING_SUCCESS: 'EDIT_SINGLE_CELL_THERAPY_PLANNING_SUCCESS',
  EDIT_SINGLE_CELL_THERAPY_PLANNING_FAILURE: 'EDIT_SINGLE_CELL_THERAPY_PLANNING_FAILURE',
  EDIT_SINGLE_CELL_THERAPY_PLANNING_RESET: 'EDIT_SINGLE_CELL_THERAPY_PLANNING_RESET',
  EDIT_SINGLE_CELL_THERAPY_PLANNING_LOADING: 'EDIT_SINGLE_CELL_THERAPY_PLANNING_LOADING',

  UPDATE_APPOINTMENT_END_TIME_REQUEST: 'UPDATE_APPOINTMENT_END_TIME_REQUEST',
  UPDATE_APPOINTMENT_END_TIME_SUCCESS: 'UPDATE_APPOINTMENT_END_TIME_SUCCESS',
  UPDATE_APPOINTMENT_END_TIME_FAILURE: 'UPDATE_APPOINTMENT_END_TIME_FAILURE',
  UPDATE_APPOINTMENT_END_TIME_RESET: 'UPDATE_APPOINTMENT_END_TIME_RESET',
  UPDATE_APPOINTMENT_END_TIME_LOADING: 'UPDATE_APPOINTMENT_END_TIME_LOADING',

  //update uncovered day

  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_SUCCESS: 'UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_SUCCESS',
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_FAILURE: 'UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_FAILURE',
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_REQUEST: 'UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_REQUEST',
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_RESET: 'UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_RESET',
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_LOADING: 'UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_LOADING',

  //get therapy planning 2.0 discharge date
  GET_THERAPY_PLANNING_DISCHARGE_SUCCESS_2_0: 'GET_THERAPY_PLANNING_DISCHARGE_SUCCESS_2_0',
  GET_THERAPY_PLANNING_DISCHARGE_FAILURE_2_0: 'GET_THERAPY_PLANNING_DISCHARGE_FAILURE_2_0',
  GET_THERAPY_PLANNING_DISCHARGE_REQUEST_2_0: 'GET_THERAPY_PLANNING_DISCHARGE_REQUEST_2_0',
  GET_THERAPY_PLANNING_DISCHARGE_RESET_2_0: 'GET_THERAPY_PLANNING_DISCHARGE_RESET_2_0',
  GET_THERAPY_PLANNING_DISCHARGE_LOADING_2_0: 'GET_THERAPY_PLANNING_DISCHARGE_LOADING_2_0',

  //copy paste 2.0
  COPY_PASTE_THERAPY_PLANNING_LOADING_2_0: 'COPY_PASTE_THERAPY_PLANNING_LOADING_2_0',
  COPY_PASTE_THERAPY_PLANNING_REQUEST_2_0: 'COPY_PASTE_THERAPY_PLANNING_REQUEST_2_0',
  COPY_PASTE_THERAPY_PLANNING_SUCCESS_2_0: 'COPY_PASTE_THERAPY_PLANNING_SUCCESS_2_0',
  COPY_PASTE_THERAPY_PLANNING_FAILURE_2_0: 'COPY_PASTE_THERAPY_PLANNING_FAILURE_2_0',
  COPY_PASTE_THERAPY_PLANNING_RESET_2_0: 'COPY_PASTE_THERAPY_PLANNING_RESET_2_0',

  //save therapy templates
  APPLY_THERAPY_TEMPLATES_REQUEST_2_0: 'APPLY_THERAPY_TEMPLATES_REQUEST_2_0',
  APPLY_THERAPY_TEMPLATES_SUCCESS_2_0: 'APPLY_THERAPY_TEMPLATES_SUCCESS_2_0',
  APPLY_THERAPY_TEMPLATES_FAILURE_2_0: 'APPLY_THERAPY_TEMPLATES_FAILURE_2_0',
  APPLY_THERAPY_TEMPLATES_LOADING_2_0: 'APPLY_THERAPY_TEMPLATES_LOADING_2_0',
  APPLY_THERAPY_TEMPLATES_RESET_2_0: 'APPLY_THERAPY_TEMPLATES_RESET_2_0',

  //get all templates
  GET_ALL_THERAPY_TEMPLATES_SUCCESS_2_0: 'GET_ALL_THERAPY_TEMPLATES_SUCCESS_2_0',
  GET_ALL_THERAPY_TEMPLATES_FAILURE_2_0: 'GET_ALL_THERAPY_TEMPLATES_FAILURE_2_0',
  GET_ALL_THERAPY_TEMPLATES_LOADING_2_0: 'GET_ALL_THERAPY_TEMPLATES_LOADING_2_0',
  GET_ALL_THERAPY_TEMPLATES_RESET_2_0: 'GET_ALL_THERAPY_TEMPLATES_RESET_2_0',
  GET_ALL_THERAPY_TEMPLATES_REQUEST_2_0: 'GET_ALL_THERAPY_TEMPLATES_REQUEST_2_0',

  //apply selected templates
  APPLY_SELECTED_TEMPLATES_REQUEST_2_0: 'APPLY_SELECTED_TEMPLATES_REQUEST',
  APPLY_SELECTED_TEMPLATES_SUCCESS_2_0: 'APPLY_SELECTED_TEMPLATES_SUCCESS',
  APPLY_SELECTED_TEMPLATES_FAILURE_2_0: 'APPLY_SELECTED_TEMPLATES_FAILURE',
  APPLY_SELECTED_TEMPLATES_LOADING_2_0: 'APPLY_SELECTED_TEMPLATES_LOADING',
  APPLY_SELECTED_TEMPLATES_RESET_2_0: 'APPLY_SELECTED_TEMPLATES_RESET',

  // get MDS ASSESSMENT therapy planning range

  GET_MDS_ASSESSMENT_RANGE_REQUEST: 'GET_MDS_ASSESSMENT_RANGE_REQUEST',
  GET_MDS_ASSESSMENT_RANGE_SUCCESS: 'GET_MDS_ASSESSMENT_RANGE_SUCCESS',
  GET_MDS_ASSESSMENT_RANGE_FAILURE: 'GET_MDS_ASSESSMENT_RANGE_FAILURE',
  GET_MDS_ASSESSMENT_RANGE_LOADING: 'GET_MDS_ASSESSMENT_RANGE_LOADING',
  GET_MDS_ASSESSMENT_RANGE_RESET: 'GET_MDS_ASSESSMENT_RANGE_RESET',

  // get payer day count for therapy planning week
  GET_PAYER_DAY_COUNT_REQUEST: 'GET_PAYER_DAY_COUNT_REQUEST',
  GET_PAYER_DAY_COUNT_SUCCESS: 'GET_PAYER_DAY_COUNT_SUCCESS',
  GET_PAYER_DAY_COUNT_FAILURE: 'GET_PAYER_DAY_COUNT_FAILURE',
  GET_PAYER_DAY_COUNT_LOADING: 'GET_PAYER_DAY_COUNT_LOADING',
  GET_PAYER_DAY_COUNT_RESET: 'GET_PAYER_DAY_COUNT_RESET',

  // THIN-8151: the MDS days 1-8 window a 5-Day (PPS) ARD must fall in
  GET_FIVE_DAY_ARD_WINDOW_REQUEST: 'GET_FIVE_DAY_ARD_WINDOW_REQUEST',
  GET_FIVE_DAY_ARD_WINDOW_SUCCESS: 'GET_FIVE_DAY_ARD_WINDOW_SUCCESS',
  GET_FIVE_DAY_ARD_WINDOW_FAILURE: 'GET_FIVE_DAY_ARD_WINDOW_FAILURE',
  GET_FIVE_DAY_ARD_WINDOW_LOADING: 'GET_FIVE_DAY_ARD_WINDOW_LOADING',
  GET_FIVE_DAY_ARD_WINDOW_RESET: 'GET_FIVE_DAY_ARD_WINDOW_RESET',

  //get single mds assessment
  GET_SINGLE_MDS_ASSESSMENT_REQUEST: 'GET_SINGLE_MDS_ASSESSMENT_REQUEST',
  GET_SINGLE_MDS_ASSESSMENT_SUCCESS: 'GET_SINGLE_MDS_ASSESSMENT_SUCCESS',
  GET_SINGLE_MDS_ASSESSMENT_FAILURE: 'GET_SINGLE_MDS_ASSESSMENT_FAILURE',
  GET_SINGLE_MDS_ASSESSMENT_LOADING: 'GET_SINGLE_MDS_ASSESSMENT_LOADING',
  GET_SINGLE_MDS_ASSESSMENT_RESET: 'GET_SINGLE_MDS_ASSESSMENT_RESET',

  //delete mds assessment by date

  DELETE_MDS_ASSESSMENT_BY_DATE_REQUEST: 'DELETE_MDS_ASSESSMENT_BY_DATE_REQUEST',
  DELETE_MDS_ASSESSMENT_BY_DATE_SUCCESS: 'DELETE_MDS_ASSESSMENT_BY_DATE_SUCCESS',
  DELETE_MDS_ASSESSMENT_BY_DATE_FAILURE: 'DELETE_MDS_ASSESSMENT_BY_DATE_FAILURE',
  DELETE_MDS_ASSESSMENT_BY_DATE_RESET: 'DELETE_MDS_ASSESSMENT_BY_DATE_RESET',
  DELETE_MDS_ASSESSMENT_BY_DATE_LOADING: 'DELETE_MDS_ASSESSMENT_BY_DATE_LOADING',

  //delete single mds assessment

  DELETE_SINGLE_MDS_ASSESSMENT_BY_REQUEST: 'DELETE_SINGLE_MDS_ASSESSMENT_BY_REQUEST',
  DELETE_SINGLE_MDS_ASSESSMENT_BY_SUCCESS: 'DELETE_SINGLE_MDS_ASSESSMENT_BY_SUCCESS',
  DELETE_SINGLE_MDS_ASSESSMENT_BY_FAILURE: 'DELETE_SINGLE_MDS_ASSESSMENT_BY_FAILURE',
  DELETE_SINGLE_MDS_ASSESSMENT_BY_RESET: 'DELETE_SINGLE_MDS_ASSESSMENT_BY_RESET',
  DELETE_SINGLE_MDS_ASSESSMENT_BY_LOADING: 'DELETE_SINGLE_MDS_ASSESSMENT_BY_LOADING',

  // get 7 day look back data
  GET_7DAY_LOOK_BACK_SUM_REQUEST: 'GET_7DAY_LOOK_BACK_SUM_REQUEST',
  GET_7DAY_LOOK_BACK_SUM_SUCCESS: 'GET_7DAY_LOOK_BACK_SUM_SUCCESS',
  GET_7DAY_LOOK_BACK_SUM_FAILURE: 'GET_7DAY_LOOK_BACK_SUM_FAILURE',
  GET_7DAY_LOOK_BACK_SUM_RESET: 'GET_7DAY_LOOK_BACK_SUM_RESET',
  GET_7DAY_LOOK_BACK_SUM_LOADING: 'GET_7DAY_LOOK_BACK_SUM_LOADING',

  //check split min task in template planner
  CHECK_SPLIT_TEMPLATE_REQUEST: 'CHECK_SPLIT_TEMPLATE_REQUEST',
  CHECK_SPLIT_TEMPLATE_SUCCESS: 'CHECK_SPLIT_TEMPLATE_SUCCESS',
  CHECK_SPLIT_TEMPLATE_FAILURE: 'CHECK_SPLIT_TEMPLATE_FAILURE',
  CHECK_SPLIT_TEMPLATE_LOADING: 'CHECK_SPLIT_TEMPLATE_LOADING',
  CHECK_SPLIT_TEMPLATE_RESET: 'CHECK_SPLIT_TEMPLATE_RESET',
};

export const newTherapyTemplateAction = {
  //create new therapy template
  CREATE_NEW_THERAPY_TEMPLATE_REQUEST: 'CREATE_NEW_THERAPY_TEMPLATE_REQUEST',
  CREATE_NEW_THERAPY_TEMPLATE_LOADING: 'CREATE_NEW_THERAPY_TEMPLATE_LOADING',
  CREATE_NEW_THERAPY_TEMPLATE_SUCCESS: 'CREATE_NEW_THERAPY_TEMPLATE_SUCCESS',
  CREATE_NEW_THERAPY_TEMPLATE_FAILURE: 'CREATE_NEW_THERAPY_TEMPLATE_FAILURE',
  CREATE_NEW_THERAPY_TEMPLATE_RESET: 'CREATE_NEW_THERAPY_TEMPLATE_RESET',

  DELETE_THERAPY_TEMPLATE_REQUEST: 'DELETE_THERAPY_TEMPLATE_REQUEST',
  DELETE_THERAPY_TEMPLATE_LOADING: 'DELETE_THERAPY_TEMPLATE_LOADING',
  DELETE_THERAPY_TEMPLATE_SUCCESS: 'DELETE_THERAPY_TEMPLATE_SUCCESS',
  DELETE_THERAPY_TEMPLATE_FAILURE: 'DELETE_THERAPY_TEMPLATE_FAILURE',
  DELETE_THERAPY_TEMPLATE_RESET: 'DELETE_THERAPY_TEMPLATE_RESET',

  EDIT_THERAPY_TEMPLATE_REQUEST: 'EDIT_THERAPY_TEMPLATE_REQUEST',
  EDIT_THERAPY_TEMPLATE_LOADING: 'EDIT_THERAPY_TEMPLATE_LOADING',
  EDIT_THERAPY_TEMPLATE_SUCCESS: 'EDIT_THERAPY_TEMPLATE_SUCCESS',
  EDIT_THERAPY_TEMPLATE_FAILURE: 'EDIT_THERAPY_TEMPLATE_FAILURE',
  EDIT_THERAPY_TEMPLATE_RESET: '  EDIT_THERAPY_TEMPLATE_RESET',
};

export const TherapistAction = {
  THERAPIST_PROFILE_REQUEST: 'THERAPIST_PROFILE_REQUEST',
  THERAPIST_PROFILE_SUCCESS: 'THERAPIST_PROFILE_SUCCESS',
  THERAPIST_PROFILE_FAILURE: 'THERAPIST_PROFILE_FAILURE',
  GET_ALL_THERAPIST_TASK_REQUEST: 'GET_ALL_THERAPIST_TASK_REQUEST',
  GET_ALL_THERAPIST_TASK_SUCCESS: 'GET_ALL_THERAPIST_TASK_SUCCESS',
  GET_ALL_THERAPIST_TASK_FAILURE: 'GET_ALL_THERAPIST_TASK_FAILURE',
  GET_ALL_THERAPIST_TASK_RESET: 'GET_ALL_THERAPIST_TASK_RESET',
  UPDATE_TIME_BASIS_REQUEST: 'UPDATE_TIME_BASIS_REQUEST',
  UPDATE_TIME_BASIS_SUCCESS: 'UPDATE_TIME_BASIS_SUCCESS',
  UPDATE_TIME_BASIS_FAILURE: 'UPDATE_TIME_BASIS_FAILURE',
  UPDATE_TIME_BASIS_LOADING: 'UPDATE_TIME_BASIS_LOADING',
  UPDATE_TIME_BASIS_RESET: 'UPDATE_TIME_BASIS_RESET',
  GET_ALL_TASK_TYPE_REQUEST: 'GET_ALL_TASK_TYPE_REQUEST',
  GET_ALL_TASK_TYPE_SUCCESS: 'GET_ALL_TASK_TYPE_SUCCESS',
  GET_ALL_TASK_TYPE_FAILURE: 'GET_ALL_TASK_TYPE_FAILURE',
  GET_ALL_THERAPIST_LIST_TYPE_REQUEST: 'GET_ALL_THERAPIST_LIST_TYPE_REQUEST',
  GET_ALL_THERAPIST_LIST_TYPE_SUCCESS: 'GET_ALL_THERAPIST_LIST_TYPE_SUCCESS',
  GET_ALL_THERAPIST_LIST_TYPE_FAILURE: 'GET_ALL_THERAPIST_LIST_TYPE_FAILURE',
  GET_ALL_THERAPIST_LIST_TYPE_RESET: 'GET_ALL_THERAPIST_LIST_TYPE_RESET',
  GET_ALL_THERAPIST_DICIPLINE_TYPE_REQUEST: 'GET_ALL_THERAPIST_DICIPLINE_TYPE_REQUEST',
  GET_ALL_THERAPIST_DICIPLINE_TYPE_SUCCESS: 'GET_ALL_THERAPIST_DICIPLINE_TYPE_SUCCESS',
  GET_ALL_THERAPIST_DICIPLINE_TYPE_FAILURE: 'GET_ALL_THERAPIST_DICIPLINE_TYPE_FAILURE',

  THERAPIST_TASK_MIGRATE_REQUEST: 'THERAPIST_TASK_MIGRATE_REQUEST',
  THERAPIST_TASK_MIGRATE_RESET: 'THERAPIST_TASK_MIGRATE_RESET',
  THERAPIST_TASK_MIGRATE_SUCCESS: 'THERAPIST_TASK_MIGRATE_SUCCESS',
  THERAPIST_TASK_MIGRATE_FAILURE: 'THERAPIST_TASK_MIGRATE_FAILURE',

  MIGRATE_THERAPIST_PATIENT_REQUEST: 'MIGRATE_THERAPIST_PATIENT_REQUEST',
  MIGRATE_THERAPIST_PATIENT_RESET: 'MIGRATE_THERAPIST_PATIENT_RESET',
  MIGRATE_THERAPIST_PATIENT_SUCCESS: 'MIGRATE_THERAPIST_PATIENT_SUCCESS',
  MIGRATE_THERAPIST_PATIENT_FAILURE: 'MIGRATE_THERAPIST_PATIENT_FAILURE',

  THERAPIST_TASK_ASSIGN_REQUEST: 'THERAPIST_TASK_ASSIGN_REQUEST',
  THERAPIST_TASK_ASSIGN_RESET: 'THERAPIST_TASK_ASSIGN_RESET',
  THERAPIST_TASK_ASSIGN_SUCCESS: 'THERAPIST_TASK_ASSIGN_SUCCESS',
  THERAPIST_TASK_ASSIGN_FAILURE: 'THERAPIST_TASK_ASSIGN_FAILURE',
  THERAPIST_TASK_ASSIGN_UNDO_REQUEST: 'THERAPIST_TASK_ASSIGN_UNDO_REQUEST',
  THERAPIST_TASK_ASSIGN_UNDO_SUCCESS: 'THERAPIST_TASK_ASSIGN_UNDO_SUCCESS',
  THERAPIST_TASK_ASSIGN_UNDO_RESET: 'THERAPIST_TASK_ASSIGN_UNDO_RESET',
  THERAPIST_TASK_ASSIGN_UNDO_FAILURE: 'THERAPIST_TASK_ASSIGN_UNDO_FAILURE',
  THERAPIST_REARRANGE_TASK_REQUEST: 'THERAPIST_REARRANGE_TASK_REQUEST',
  THERAPIST_REARRANGE_TASK_SUCCESS: 'THERAPIST_REARRANGE_TASK_SUCCESS',
  THERAPIST_REARRANGE_TASK_FAILURE: 'THERAPIST_REARRANGE_TASK_FAILURE',
  EDIT_TASK_REQUEST: 'EDIT_TASK_REQUEST',
  EDIT_TASK_RESET: 'EDIT_TASK_RESET',
  EDIT_TASK_SUCCESS: 'EDIT_TASK_SUCCESS',
  EDIT_TASK_FAILURE: 'EDIT_TASK_FAILURE',
  THERAPIST_DIALOG_ASSIGN_TASK_REQUEST: 'THERAPIST_DIALOG_ASSIGN_TASK_REQUEST',
  THERAPIST_DIALOG_ASSIGN_TASK_RESET: 'THERAPIST_DIALOG_ASSIGN_TASK_RESET',
  THERAPIST_DIALOG_ASSIGN_TASK_SUCCESS: 'THERAPIST_DIALOG_ASSIGN_TASK_SUCCESS',
  THERAPIST_DIALOG_ASSIGN_TASK_FAILURE: 'THERAPIST_DIALOG_ASSIGN_TASK_FAILURE',
  REQUEST_GET_ALL_THERAPIST: 'REQUEST_GET_ALL_THERAPIST',
  SUCCESS_GET_ALL_THERAPIST: 'SUCCESS_GET_ALL_THERAPIST',
  FAILURE_GET_ALL_THERAPIST: 'FAILURE_GET_ALL_THERAPIST',
  LOADING_GET_ALL_THERAPIST: 'LOADING_GET_ALL_THERAPIST',
  THERAPIST_PROFILE_RESET: 'THERAPIST_PROFILE_RESET',
  PRE_THERAPIST_PROFILE_REQUEST: 'PRE_THERAPIST_PROFILE_REQUEST',
  PRE_THERAPIST_PROFILE_SUCCESS: 'PRE_THERAPIST_PROFILE_SUCCESS',
  PRE_THERAPIST_PROFILE_FAILURE: 'PRE_THERAPIST_PROFILE_FAILURE',

  THERAPIST_PATIENT_UNASSIGN_REQUEST: 'THERAPIST_PATIENT_UNASSIGN_REQUEST',
  THERAPIST_PATIENT_UNASSIGN_SUCCESS: 'THERAPIST_PATIENT_UNASSIGN_SUCCESS',
  THERAPIST_PATIENT_UNASSIGN_RESET: 'THERAPIST_PATIENT_UNASSIGN_RESET',
  THERAPIST_PATIENT_UNASSIGN_FAILURE: 'THERAPIST_PATIENT_UNASSIGN_FAILURE',

  // AutoMatching
  THERAPIST_AUTO_MATCHING_REQUEST: 'THERAPIST_AUTO_MATCHING_REQUEST',
  THERAPIST_AUTO_MATCHING_SUCCESS: 'THERAPIST_AUTO_MATCHING_SUCCESS',
  THERAPIST_AUTO_MATCHING_FAILURE: 'THERAPIST_AUTO_MATCHING_FAILURE',
  THERAPIST_AUTO_MATCHING_LOADING: 'THERAPIST_AUTO_MATCHING_LOADING',
  THERAPIST_AUTO_MATCHING_RESET: 'THERAPIST_AUTO_MATCHING_RESET',
  THERAPIST_DEFUALT_THERAPIST_REQUEST: 'THERAPIST_DEFAULT_THERAPIST_REQUEST',
  THERAPIST_DEFAULT_THERAPIST_SUCCESS: 'THERAPIST_DEFAULT_THERAPIST_SUCCESS',
  THERAPIST_DEFAULT_THERAPIST_FAILURE: 'THERAPIST_DEFAULT_THERAPIST_FAILURE',
  THERAPIST_DEFAULT_THERAPIST_RESET: 'THERAPIST_AUTO_MATCHING_RESET',
  DISABLE_AUTO_MATCH_REQUEST: 'DISABLE_AUTO_MATCH_REQUEST',
  DISABLE_AUTO_MATCH_SUCCESS: 'DISABLE_AUTO_MATCH_SUCCESS',
  DISABLE_AUTO_MATCH_FAILURE: 'DISABLE_AUTO_MATCH_FAILURE',

  //paycome
  GET_PAYCOME_PROVIDER_REQUEST: 'GET_PAYCOME_PROVIDER_REQUEST',
  GET_PAYCOME_PROVIDER_SUCCESS: 'GET_PAYCOME_PROVIDER_SUCCESS',
  GET_PAYCOME_PROVIDER_FAILURE: 'GET_PAYCOME_PROVIDER_FAILURE',
  GET_PAYCOME_PROVIDER_LOADER: 'GET_PAYCOME_PROVIDER_LOADER',
  GET_PAYCOME_PROVIDER_RESET: 'GET_PAYCOME_PROVIDER_RESET',

  //clock in/out button visibility (per-facility flag) - APIT-587
  GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_REQUEST: 'GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_REQUEST',
  GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_SUCCESS: 'GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_SUCCESS',
  GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_FAILURE: 'GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_FAILURE',
  GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_LOADER: 'GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_LOADER',
  GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_RESET: 'GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_RESET',

  // setting common duration to G&C tasks
  SET_COMMON_DURATION_FOR_GC_REQUEST: 'SET_COMMON_DURATION_FOR_GC_REQUEST',
  SET_COMMON_DURATION_FOR_GC_SUCCESS: 'SET_COMMON_DURATION_FOR_GC_SUCCESS',
  SET_COMMON_DURATION_FOR_GC_FAILURE: 'SET_COMMON_DURATION_FOR_GC_FAILURE',
  SET_COMMON_DURATION_FOR_GC_RESET: 'SET_COMMON_DURATION_FOR_GC_RESET',

  GET_APPOINTMENT_SLOTS_REQUEST: 'GET_APPOINTMENT_SLOTS_REQUEST',
  GET_APPOINTMENT_SLOTS_SUCCESS: 'GET_APPOINTMENT_SLOTS_SUCCESS',
  GET_APPOINTMENT_SLOTS_FAILURE: 'GET_APPOINTMENT_SLOTS_FAILURE',
  GET_APPOINTMENT_SLOTS_RESET: 'GET_APPOINTMENT_SLOTS_RESET',
  SCHEDULE_APPOINTMENT_REQUEST: 'SCHEDULE_APPOINTMENT_REQUEST',
  SCHEDULE_APPOINTMENT_SUCCESS: 'SCHEDULE_APPOINTMENT_SUCCESS',
  SCHEDULE_APPOINTMENT_FAILURE: 'SCHEDULE_APPOINTMENT_FAILURE',
  SCHEDULE_APPOINTMENT_RESET: 'SCHEDULE_APPOINTMENT_RESET',
  SCHEDULE_RECURRING_APPOINTMENT_REQUEST: 'SCHEDULE_RECURRING_APPOINTMENT_REQUEST',
  SCHEDULE_RECURRING_APPOINTMENT_SUCCESS: 'SCHEDULE_RECURRING_APPOINTMENT_SUCCESS',
  SCHEDULE_RECURRING_APPOINTMENT_FAILURE: 'SCHEDULE_RECURRING_APPOINTMENT_FAILURE',
  SCHEDULE_RECURRING_APPOINTMENT_RESET: 'SCHEDULE_RECURRING_APPOINTMENT_RESET',

  UPDATE_RECURRING_SERIES_REQUEST: 'UPDATE_RECURRING_SERIES_REQUEST',
  UPDATE_RECURRING_SERIES_SUCCESS: 'UPDATE_RECURRING_SERIES_SUCCESS',
  UPDATE_RECURRING_SERIES_FAILURE: 'UPDATE_RECURRING_SERIES_FAILURE',
  UPDATE_RECURRING_SERIES_RESET: 'UPDATE_RECURRING_SERIES_RESET',

  CANCEL_RECURRING_SERIES_REQUEST: 'CANCEL_RECURRING_SERIES_REQUEST',
  CANCEL_RECURRING_SERIES_SUCCESS: 'CANCEL_RECURRING_SERIES_SUCCESS',
  CANCEL_RECURRING_SERIES_FAILURE: 'CANCEL_RECURRING_SERIES_FAILURE',
  CANCEL_RECURRING_SERIES_RESET: 'CANCEL_RECURRING_SERIES_RESET',
  GET_PATIENT_TIME_SLOTS_REQUEST: 'GET_PATIENT_TIME_SLOTS_REQUEST',
  GET_PATIENT_TIME_SLOTS_SUCCESS: 'GET_PATIENT_TIME_SLOTS_SUCCESS',
  GET_PATIENT_TIME_SLOTS_FAILURE: 'GET_PATIENT_TIME_SLOTS_FAILURE',
  GET_PATIENT_TIME_SLOTS_RESET: 'GET_PATIENT_TIME_SLOTS_RESET',
  SET_IS_RECURRING_EDIT: 'SET_IS_RECURRING_EDIT',
  RESET_IS_RECURRING_EDIT: 'RESET_IS_RECURRING_EDIT',
  GET_RECURRING_APPOINTMENT_COUNT_REQUEST: 'GET_RECURRING_APPOINTMENT_COUNT_REQUEST',
  GET_RECURRING_APPOINTMENT_COUNT_SUCCESS: 'GET_RECURRING_APPOINTMENT_COUNT_SUCCESS',
  GET_RECURRING_APPOINTMENT_COUNT_FAILURE: 'GET_RECURRING_APPOINTMENT_COUNT_FAILURE',
  GET_RECURRING_APPOINTMENT_COUNT_RESET: 'GET_RECURRING_APPOINTMENT_COUNT_RESET',
};

export const schedularTherapistFilterAction = {
  SET_THERAPIST_FILTER_IN_SCHUDLAR: 'SET_THERAPIST_FILTER_IN_SCHUDLAR',
  RESET_THERAPIST_FILTER_IN_SCHUDLAR: 'RESET_THERAPIST_FILTER_IN_SCHUDLAR',
  GET_ALL_FILTERED_THERAPIST_REQUEST: 'GET_ALL_FILTERED_THERAPIST_REQUEST',

  GET_ALL_MAINTAINED_THERAPISTS_REQUEST: 'GET_ALL_MAINTAINED_THERAPISTS_REQUEST',
  GET_ALL_MAINTAINED_THERAPISTS_SUCCESS: 'GET_ALL_MAINTAINED_THERAPISTS_SUCCESS',
  GET_ALL_MAINTAINED_THERAPISTS_FAILURE: 'GET_ALL_MAINTAINED_THERAPISTS_FAILURE',
  GET_ALL_MAINTAINED_THERAPISTS_RESET: 'GET_ALL_MAINTAINED_THERAPISTS_RESET',

  MAINTAIN_THERAPIST_FILTER_REQUEST: 'MAINTAIN_THERAPIST_FILTER_REQUEST',
  MAINTAIN_THERAPIST_FILTER_SUCCESS: 'MAINTAIN_THERAPIST_FILTER_SUCCESS',
  MAINTAIN_THERAPIST_FILTER_FAILURE: 'MAINTAIN_THERAPIST_FILTER_FAILURE',
  // MAINTAIN_THERAPIST_FILTER_RESET: 'MAINTAIN_THERAPIST_FILTER_RESET',

  // split task
  SPLIT_TASK_MIN_REQUEST: 'SPLIT_TASK_MIN_REQUEST',
  SPLIT_TASK_MIN_SUCCESS: 'SPLIT_TASK_MIN_SUCCESS',
  SPLIT_TASK_MIN_FAILURE: 'SPLIT_TASK_MIN_FAILURE',
  SPLIT_TASK_MIN_LOADING: 'SPLIT_TASK_MIN_LOADING',
  SPLIT_TASK_MIN_RESET: 'SPLIT_TASK_MIN_RESET',

  //edit spit min
  EDIT_SPLIT_TASK_MIN_REQUEST: 'EDIT_SPLIT_TASK_MIN_REQUEST',
  EDIT_SPLIT_TASK_MIN_SUCCESS: 'EDIT_SPLIT_TASK_MIN_SUCCESS',
  EDIT_SPLIT_TASK_MIN_FAILURE: 'EDIT_SPLIT_TASK_MIN_FAILURE',
  EDIT_SPLIT_TASK_MIN_LOADING: 'EDIT_SPLIT_TASK_MIN_LOADING',
  EDIT_SPLIT_TASK_MIN_RESET: 'EDIT_SPLIT_TASK_MIN_RESET',

  //get split task
  GET_SPLIT_TASK_REQUEST: 'GET_SPLIT_TASK_REQUEST',
  GET_SPLIT_TASK_SUCCESS: 'GET_SPLIT_TASK_SUCCESS',
  GET_SPLIT_TASK_FAILURE: 'GET_SPLIT_TASK_FAILURE',
  GET_SPLIT_TASK_LOADING: 'GET_SPLIT_TASK_LOADING',
  GET_SPLIT_TASK_RESET: 'GET_SPLIT_TASK_RESET',

  //delete split task
  DELETE_SPLIT_TASK_REQUEST: 'DELETE_SPLIT_TASK_REQUEST',
  DELETE_SPLIT_TASK_SUCCESS: 'DELETE_SPLIT_TASK_SUCCESS',
  DELETE_SPLIT_TASK_FAILURE: 'DELETE_SPLIT_TASK_FAILURE',
  DELETE_SPLIT_TASK_RESET: 'DELETE_SPLIT_TASK_RESET',
  DELETE_SPLIT_TASK_LOADING: 'DELETE_SPLIT_TASK_LOADING',
};

export const schedularAnnouncementActions = {
  GET_ALL_ANNOUNCEMENTS_REQUEST: 'GET_ALL_ANNOUNCEMENTS_REQUEST',
  GET_ALL_ANNOUNCEMENTS_LOADING: 'GET_ALL_ANNOUNCEMENTS_LOADING',
  GET_ALL_ANNOUNCEMENTS_SUCCESS: 'GET_ALL_ANNOUNCEMENTS_SUCCESS',
  GET_ALL_ANNOUNCEMENTS_FAILURE: 'GET_ALL_ANNOUNCEMENTS_FAILURE',
  GET_ALL_ANNOUNCEMENTS_RESET: 'GET_ALL_ANNOUNCEMENTS_RESET',

  CREATE_ANNOUNCEMENT_REQUEST: 'CREATE_ANNOUNCEMENT_REQUEST',
  CREATE_ANNOUNCEMENT_LOADING: 'CREATE_ANNOUNCEMENT_LOADING',
  CREATE_ANNOUNCEMENT_SUCCESS: 'CREATE_ANNOUNCEMENT_SUCCESS',
  CREATE_ANNOUNCEMENT_FAILURE: 'CREATE_ANNOUNCEMENT_FAILURE',
  CREATE_ANNOUNCEMENT_RESET: 'CREATE_ANNOUNCEMENT_RESET',

  UPDATE_ANNOUNCEMENT_REQUEST: 'UPDATE_ANNOUNCEMENT_REQUEST',
  UPDATE_ANNOUNCEMENT_LOADING: 'UPDATE_ANNOUNCEMENT_LOADING',
  UPDATE_ANNOUNCEMENT_SUCCESS: 'UPDATE_ANNOUNCEMENT_SUCCESS',
  UPDATE_ANNOUNCEMENT_FAILURE: 'UPDATE_ANNOUNCEMENT_FAILURE',
  UPDATE_ANNOUNCEMENT_RESET: 'UPDATE_ANNOUNCEMENT_RESET',

  DELETE_ANNOUNCEMENT_REQUEST: 'DELETE_ANNOUNCEMENT_REQUEST',
  DELETE_ANNOUNCEMENT_SUCCESS: 'DELETE_ANNOUNCEMENT_SUCCESS',
  DELETE_ANNOUNCEMENT_FAILURE: 'DELETE_ANNOUNCEMENT_FAILURE',
  DELETE_ANNOUNCEMENT_RESET: 'DELETE_ANNOUNCEMENT_RESET',
};

export const selectedPatient = {
  SELECT_PATIENT_FOR_THERAPY: 'SELECT_PATIENT_FOR_THERAPY',
  SELECT_PATIENT_LIST_FOR_THERAPY: 'SELECT_PATIENT_LIST_FOR_THERAPY',
  RESET_PATIENT_FOR_THERAPY: 'RESET_PATIENT_FOR_THERAPY',
};

export const PatientActions = {
  GET_SINGLE_PATIENT_SUCCESS: 'GET_SINGLE_PATIENT_SUCCESS',
  GET_SINGLE_PATIENT_REQUEST: 'GET_SINGLE_PATIENT_REQUEST',
  GET_SINGLE_PATIENT_LOADING: 'GET_SINGLE_PATIENT_LOADING',
  GET_SINGLE_PATIENT_FAILURE: 'GET_SINGLE_PATIENT_FAILURE',

  REQUEST_CREATE_PATIENT: 'REQUEST_CREATE_PATIENT',
  SUCCESS_CREATE_PATIENT: 'SUCCESS_CREATE_PATIENT',
  FAILURE_CREATE_PATIENT: 'FAILURE_CREATE_PATIENT',
  LOADING_CREATE_PATIENT: 'LOADING_CREATE_PATIENT',
  RESET_CREATE_PATIENT: 'RESET_CREATE_PATIENT',
  REQUEST_EDIT_PATIENT: 'REQUEST_EDIT_PATIENT',
  SUCCESS_EDIT_PATIENT: 'SUCCESS_EDIT_PATIENT',
  FAILURE_EDIT_PATIENT: 'FAILURE_EDIT_PATIENT',
  LOADING_EDIT_PATIENT: 'LOADING_EDIT_PATIENT',
  RESET_EDIT_PATIENT: 'RESET_EDIT_PATIENT',
  REQUEST_DEACTIVATE_PATIENT: 'REQUEST_DEACTIVATE_PATIENT',
  SUCCESS_DEACTIVATE_PATIENT: 'SUCCESS_DEACTIVATE_PATIENT',
  LOADING_DEACTIVATE_PATIENT: 'LOADING_DEACTIVATE_PATIENT',
  FAILURE_DEACTIVATE_PATIENT: 'FAILURE_DEACTIVATE_PATIENT',
  RESET_DEACTIVATE_PATIENT: 'RESET_DEACTIVATE_PATIENT',
  REQUEST_PATIENT_ID: 'REQUEST_PATIENT_ID',
  SUCCESS_PATIENT_ID: 'SUCCESS_PATIENT_ID',
  FAILURE_PATIENT_ID: 'FAILURE_PATIENT_ID',
  GET_REQUEST_ENTERPRISE_PHYSICIAN: 'GET_REQUEST_ENTERPRISE_PHYSICIAN',
  GET_SUCCESS_ENTERPRISE_PHYSICIAN: 'GET_SUCCESS_ENTERPRISE_PHYSICIAN',
  GET_FAILURE_ENTERPRISE_PHYSICIAN: 'GET_FAILURE_ENTERPRISE_PHYSICIAN',
  GET_FAILURE_ENTERPRISE_LOADER: 'GET_FAILURE_ENTERPRISE_LOADER',

  GET_PAYER_PLAN_TYPE_REQUEST: 'GET_PAYER_PLAN_TYPE_REQUEST',
  GET_PAYER_PLAN_TYPE_SUCCESS: 'GET_PAYER_PLAN_TYPE_SUCCESS',
  GET_PAYER_PLAN_TYPE_FAILURE: 'GET_PAYER_PLAN_TYPE_FAILURE',

  REQUEST_PATIENT_IN_ACTIVE_COUNT: 'REQUEST_PATIENT_IN_ACTIVE_COUNT',
  SUCCESS_PATIENT_IN_ACTIVE_COUNT: 'SUCCESS_PATIENT_IN_ACTIVE_COUNT',
  FAILURE_PATIENT_IN_ACTIVE_COUNT: 'FAILURE_PATIENT_IN_ACTIVE_COUNT',
  SUCCESS_PATIENT_IN_ACTIVE_COUNT_LOADING: 'SUCCESS_PATIENT_IN_ACTIVE_COUNT_LOADING',
  SWITCH_THERAPIST_DISCIPLINE: 'SWITCH_THERAPIST_DISCIPLINE',

  GET_ALL_PATIENT_PRIOR_CHARGES_REQUEST: 'GET_ALL_PATIENT_PRIOR_CHARGES_REQUEST',
  GET_ALL_PATIENT_PRIOR_CHARGES_SUCCESS: 'GET_ALL_PATIENT_PRIOR_CHARGES_SUCCESS',
  GET_ALL_PATIENT_PRIOR_CHARGES_FAILURE: 'GET_ALL_PATIENT_PRIOR_CHARGES_FAILURE',
  GET_ALL_PATIENT_PRIOR_CHARGES_RESET: 'GET_ALL_PATIENT_PRIOR_CHARGES_RESET',
};

export const facilityAction = {
  GET_ASSIGNED_FACILITY_REQUEST: 'GET_ASSIGNED_FACILITY_REQUEST',
  GET_ASSIGNED_FACILITY_SUCCESS: 'GET_ASSIGNED_FACILITY_SUCCESS',
  GET_ASSIGNED_FACILITY_FAILURE: 'GET_ASSIGNED_FACILITY_FAILURE',
  SWITCH_FACILITY_REQUEST: 'SWITCH_FACILITY_REQUEST',
  SWITCH_FACILITY_SUCCESS: 'SWITCH_FACILITY_SUCCESS',
  SWITCH_FACILITY_FAILURE: 'SWITCH_FACILITY_FAILURE',
  SWITCH_FACILITY_LOADER: 'SWITCH_FACILITY_LOADER',
  SWITCH_FACILITY_RESET: 'SWITCH_FACILITY_RESET',
  STORE_FACILITY_UUID: 'STORE_FACILITY_UUID',
  PRE_GET_ASSIGNED_FACILITY_REQUEST: 'PRE_GET_ASSIGNED_FACILITY_REQUEST',
  PRE_GET_ASSIGNED_FACILITY_SUCCESS: 'PRE_GET_ASSIGNED_FACILITY_SUCCESS',
  PRE_GET_ASSIGNED_FACILITY_FAILURE: 'PRE_GET_ASSIGNED_FACILITY_FAILURE',
};

export const LOADER_ON = 'LOADER_ON';
export const LOADER_OFF = 'LOADER_OFF';

export const contract = {
  GET_CONTRACT_COUNT_REQUEST: 'GET_CONTRACT_COUNT_REQUEST',
  GET_CONTRACT_COUNT_SUCCESS: 'GET_CONTRACT_COUNT_SUCCESS',
  GET_CONTRACT_COUNT_FAILURE: 'GET_CONTRACT_COUNT_FAILURE',
};

export const patientAction = {
  GET_PATIENT_REQUEST: 'GET_PATIENT_REQUEST',
  GET_PATIENT_SUCCESS: 'GET_PATIENT_SUCCESS',
  GET_PATIENT_FAILURE: 'GET_PATIENT_FAILURE',
  GET_PATIENT_LOADING: 'GET_PATIENT_LOADING',

  //patient list

  GET_ALL_PATIENT_LIST_REQUEST: 'GET_ALL_PATIENT_LIST_REQUEST',
  GET_ALL_PATIENT_LIST_SUCCESS: 'GET_ALL_PATIENT_LIST_SUCCESS',
  GET_ALL_PATIENT_LIST_FAILURE: 'GET_ALL_PATIENT_LIST_FAILURE',
  GET_ALL_PATIENT_LIST_LOADING: 'GET_ALL_PATIENT_LIST_LOADING',
  GET_ALL_PATIENT_LIST_RESET: 'GET_ALL_PATIENT_LIST_RESET',
  PERSISTS_BACK_PATIENT: 'PERSISTS_BACK_PATIENT',
  PERSISTS_BACK_PATIENT_CRITERIA: 'PERSISTS_BACK_PATIENT_CRITERIA',
  PERSIST_PATIENT_STATUS_FILTER: 'PERSIST_PATIENT_STATUS_FILTER',
  PERSIST_PATIENT_ACTIVE_CERT: 'PERSIST_PATIENT_ACTIVE_CERT',

  REQUEST_CREATE_PATIENT: 'REQUEST_CREATE_PATIENT',
  SUCCESS_CREATE_PATIENT: 'SUCCESS_CREATE_PATIENT',
  FAILURE_CREATE_PATIENT: 'FAILURE_CREATE_PATIENT',
  RESET_CREATE_PATIENT: 'RESET_CREATE_PATIENT',
  GET_THERAPIST_DISCIPLINE_SUCCESS: 'GET_THERAPIST_DISCIPLINE_SUCCESS',
  GET_THERAPIST_DISCIPLINE_FAILURE: 'GET_THERAPIST_DISCIPLINE_FAILURE',
  GET_THERAPIST_DISCIPLINE_LOADING: 'GET_THERAPIST_DISCIPLINE_LOADING',
  GET_THERAPIST_DISCIPLINE_REQUEST: 'GET_THERAPIST_DISCIPLINE_REQUEST',

  GET_THERAPIST_SINGLE_DISCIPLINE_SUCCESS: 'GET_THERAPIST_SINGLE_DISCIPLINE_SUCCESS',
  GET_THERAPIST_SINGLE_DISCIPLINE_FAILURE: 'GET_THERAPIST_SINGLE_DISCIPLINE_FAILURE',
  GET_THERAPIST_SINGLE_DISCIPLINE_LOADING: 'GET_THERAPIST_SINGLE_DISCIPLINE_LOADING',
  GET_THERAPIST_SINGLE_DISCIPLINE_REQUEST: 'GET_THERAPIST_SINGLE_DISCIPLINE_REQUEST',

  PUT_TREATMENT_THERAPIST_SUCCESS: 'PUT_THEATMENT_THERAPIST_SUCCESS',
  PUT_TREATMENT_THERAPIST_FAILURE: 'PUT_TREATMENT_THERAPIST_FAILURE',
  PUT_TREATMENT_THERAPIST_RESET: 'PUT_TREATMENT_THERAPIST_RESET',
  PUT_TREATMENT_THERAPIST_REQUEST: 'GET_TREATMENT_THERAPIST_REQUEST',

  GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_REQUEST: 'GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_REQUEST',
  GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_SUCCESS: 'GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_SUCCESS',
  GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_FAILURE: 'GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_FAILURE',
  GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_LOADING: 'GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_LOADING',

  REQUEST_VALIDATE_CSV_TEMPLATE: 'REQUEST_VALIDATE_CSV_TEMPLATE',
  SUCCESS_VALIDATE_CSV_TEMPLATE: 'SUCCESS_VALIDATE_CSV_TEMPLATE',
  FAILURE_VALIDATE_CSV_TEMPLATE: 'FAILURE_VALIDATE_CSV_TEMPLATE',
  RESET_VALIDATE_CSV_TEMPLATE: 'RESET_VALIDATE_CSV_TEMPLATE',

  REQUEST_UPLOAD_CSV_TEMPLATE: 'REQUEST_UPLOAD_CSV_TEMPLATE',
  SUCCESS_UPLOAD_CSV_TEMPLATE: 'SUCCESS_UPLOAD_CSV_TEMPLATE',
  FAILURE_UPLOAD_CSV_TEMPLATE: 'FAILURE_UPLOAD_CSV_TEMPLATE',
  RESET_UPLOAD_CSV_TEMPLATE: 'RESET_UPLOAD_CSV_TEMPLATE',

  GET_RECENT_UPLOADED_HISTORY_REQUEST: 'GET_RECENT_UPLOADED_HISTORY_REQUEST',
  GET_RECENT_UPLOADED_HISTORY_SUCCESS: 'GET_RECENT_UPLOADED_HISTORY_SUCCESS',
  GET_RECENT_UPLOADED_HISTORY_FAILURE: 'GET_RECENT_UPLOADED_HISTORY_FAILURE',
  GET_RECENT_UPLOADED_HISTORY_LOADING: 'GET_RECENT_UPLOADED_HISTORY_LOADING',
  GET_RECENT_UPLOADED_HISTORY_RESET: 'GET_RECENT_UPLOADED_HISTORY_RESET',

  GET_PATIENT_EXPORT_TEMPLATE_REQUEST: 'GET_PATIENT_EXPORT_TEMPLATE_REQUEST',
  GET_PATIENT_EXPORT_TEMPLATE_SUCCESS: 'GET_PATIENT_EXPORT_TEMPLATE_SUCCESS',
  GET_PATIENT_EXPORT_TEMPLATE_FAILURE: 'GET_PATIENT_EXPORT_TEMPLATE_FAILURE',
  GET_PATIENT_EXPORT_TEMPLATE_LOADING: 'GET_PATIENT_EXPORT_TEMPLATE_LOADING',
  GET_PATIENT_EXPORT_TEMPLATE_RESET: 'GET_PATIENT_EXPORT_TEMPLATE_RESET',

  GET_ALL_PATIENT_REQUEST: 'GET_ALL_PATIENT_REQUEST',
  GET_ALL_PATIENT_SUCCESS: 'GET_ALL_PATIENT_SUCCESS',
  GET_ALL_PATIENT_FAILURE: 'GET_ALL_PATIENT_FAILURE',
};

export const facilityStayAction = {
  REQUEST_GET_ALL_FACILITIES_STAY: 'REQUEST_GET_ALL_FACILITIES_STAY',
  SUCCESS_GET_ALL_FACILITIES_STAY: 'SUCCESS_GET_ALL_FACILITIES_STAY',
  LOADER_GET_ALL_FACILITIES_STAY: 'LOADER_GET_ALL_FACILITIES_STAY',
  FAILURE_GET_ALL_FACILITIES_STAY: 'FAILURE_GET_ALL_FACILITIES_STAY',
  REQUEST_UPDATE_FACILITY_STAY: 'REQUEST_UPDATE_FACILITY_STAY',
  SUCCESS_UPDATE_FACILITY_STAY: 'SUCCESS_UPDATE_FACILITY_STAY',
  FAILURE_UPDATE_FACILITY_STAY: 'FAILURE_UPDATE_FACILITY_STAY',
  RESET_UPDATE_FACILITY_STAY: 'RESET_UPDATE_FACILITY_STAY',
  REQUEST_CREATE_FACILITY_STAY: 'REQUEST_CREATE_FACILITY_STAY',
  SUCCESS_CREATE_FACILITY_STAY: 'SUCCESS_CREATE_FACILITY_STAY',
  FAILURE_CREATE_FACILITY_STAY: 'FAILURE_CREATE_FACILITY_STAY',
  RESET_CREATE_FACILITY_STAY: 'RESET_CREATE_FACILITY_STAY',
  UPDATE_FACILITY_LOADING: 'UPDATE_FACILITY_LOADING',
  CREATE_FACILITY_LOADING: 'CREATE_FACILITY_LOADING',

  REQUEST_GET_ALL_FACILITIES: 'REQUEST_GET_ALL_FACILITIES',
  SUCCESS_GET_ALL_FACILITIES: 'SUCCESS_GET_ALL_FACILITIES',
  FAILURE_GET_ALL_FACILITIES: 'FAILURE_GET_ALL_FACILITIES',
  RESET_GET_ALL_FACILITIES: 'RESET_GET_ALL_FACILITIES',
  CREATE_FACILITIES_LOADING: 'CREATE_FACILITIES_LOADING',

  GET_PATIENTS_REQUEST: 'GET_PATIENTS_REQUEST',
  GET_PATIENTS_SUCCESS: 'GET_PATIENTS_SUCCESS',
  GET_PATIENTS_FAILURE: 'GET_PATIENTS_FAILURE',
  GET_PATIENTS_LOADER: 'GET_PATIENTS_LOADER',
  GET_PATIENTS_RESET: 'GET_PATIENTS_RESET',
};

export const screeningAction = {
  GET_SCREENING_REQUEST: 'GET_SCREENING_REQUEST',
  GET_SCREENING_SUCCESS: 'GET_SCREENING_SUCCESS',
  GET_SCREENING_LOADER: 'GET_SCREENING_LOADER',
  GET_SCREENING_FAILURE: 'GET_SCREENING_FAILURE',
  PREVIEW_SCREENING: 'PREVIEW_SCREENING',
  CREATE_SCREENING_REQUEST: 'CREATE_SCREENING_REQUEST',
  CREATE_SCREENING_SUCCESS: 'CREATE_SCREENING_SUCCESS',
  CREATE_SCREENING_FAILURE: 'CREATE_SCREENING_FAILURE',
  RESET_CREATE_SCREENING: 'RESET_CREATE_SCREENING',
  EDIT_SCREENING_REQUEST: 'EDIT_SCREENING_REQUEST',
  EDIT_SCREENING_SUCCESS: 'EDIT_SCREENING_SUCCESS',
  EDIT_SCREENING_FAILURE: 'EDIT_SCREENING_FAILURE',
  RESET_EDIT_SCREENING: 'RESET_EDIT_SCREENING',
  GET_SCREENING_TYPE_REQUEST: 'GET_SCREENING_TYPE_REQUEST',
  GET_SCREENING_TYPE_SUCCESS: 'GET_SCREENING_TYPE_SUCCESS',
  GET_SCREENING_TYPE_FAILURE: 'GET_SCREENING_TYPE_FAILURE',
  GET_DISCIPLINE_TYPE_REQUEST: 'GET_DISCIPLINE_TYPE_REQUEST',
  GET_DISCIPLINE_TYPE_SUCCESS: 'GET_DISCIPLINE_TYPE_SUCCESS',
  GET_DISCIPLINE_TYPE_FAILURE: 'GET_DISCIPLINE_TYPE_FAILURE',
  GET_SINGLE_SCREENING_REQUEST: 'GET_SINGLE_SCREENING_REQUEST',
  GET_SINGLE_SCREENING_SUCCESS: 'GET_SINGLE_SCREENING_SUCCESS',
  GET_SINGLE_SCREENING_FAILURE: 'GET_SINGLE_SCREENING_FAILURE',

  //get Screening form id
  GET_FORM_ID_FOR_SCREENING_REQUEST: 'GET_FORM_ID_FOR_SCREENING_REQUEST',
  GET_FORM_ID_FOR_SCREENING_SUCCESS: 'GET_FORM_ID_FOR_SCREENING_SUCCESS',
  GET_FORM_ID_FOR_SCREENING_FAILURE: 'GET_FORM_ID_FOR_SCREENING_FAILURE',
  GET_FORM_ID_FOR_SCREENING_LOADER: 'GET_FORM_ID_FOR_SCREENING_LOADER',

  //post screening  submission form
  POST_SCREENING_SUBMISSION_SUCCESS: 'POST_SCREENING_SUBMISSION_SUCCESS',
  POST_SCREENING_SUBMISSION_FAILURE: 'POST_SCREENING_SUBMISSION_FAILURE',
  POST_SCREENING_SUBMISSION_LOADER: 'POST_SCREENING_SUBMISSION_LOADER',
  POST_SCREENING_SUBMISSION_REQUEST: 'POST_SCREENING_SUBMISSION_REQUEST',
  POST_SCREENING_SUBMISSION_RESET: 'POST_SCREENING_SUBMISSION_RESET',
};

export const departmentDashboard = {
  GET_DEPARTMENT_DASHBOARD_COUNT_REQUEST: 'GET_DEPARTMENT_DASHBOARD_COUNT_REQUEST',
  GET_DEPARTMENT_DASHBOARD_COUNT_SUCCESS: 'GET_DEPARTMENT_DASHBOARD_COUNT_SUCCESS',
  GET_DEPARTMENT_DASHBOARD_COUNT_FAILURE: 'GET_DEPARTMENT_DASHBOARD_COUNT_FAILURE',
  GET_DEPARTMENT_PTO_REQUEST: 'GET_DEPARTMENT_PTO_REQUEST',
  GET_DEPARTMENT_PTO_SUCCESS: 'GET_DEPARTMENT_PTO_SUCCESS',
  GET_DEPARTMENT_PTO_LOADING: 'GET_DEPARTMENT_PTO_LOADING',
  GET_DEPARTMENT_PTO_FAILURE: 'GET_DEPARTMENT_PTO_FAILURE',
  UPDATE_DEPARTMENT_PTO_REQUEST: 'UPDATE_DEPARTMENT_PTO_REQUEST',
  UPDATE_DEPARTMENT_PTO_SUCCESS: 'UPDATE_DEPARTMENT_PTO_SUCCESS',
  UPDATE_DEPARTMENT_PTO_LOADER: 'UPDATE_DEPARTMENT_PTO_LOADER',
  UPDATE_DEPARTMENT_PTO_FAILURE: 'UPDATE_DEPARTMENT_PTO_FAILURE',
  RESET_UPDATE_DEPARTMENT_PTO: 'RESET_UPDATE_DEPARTMENT_PTO',
  GET_DEPARTMENT_THERAPY_MIN_REQUEST: 'GET_DEPARTMENT_THERAPY_MIN_REQUEST',
  GET_DEPARTMENT_THERAPY_MIN_SUCCESS: 'GET_DEPARTMENT_THERAPY_MIN_SUCCESS',
  GET_DEPARTMENT_THERAPY_MIN_FAILURE: 'GET_DEPARTMENT_THERAPY_MIN_FAILURE',

  //check task of therapist
  CHECK_ASSIGN_TASK_PTO_REQUEST: 'CHECK_ASSIGN_TASK_PTO_REQUEST',
  CHECK_ASSIGN_TASK_PTO_SUCCESS: 'CHECK_ASSIGN_TASK_PTO_SUCCESS',
  CHECK_ASSIGN_TASK_PTO_FAILURE: 'CHECK_ASSIGN_TASK_PTO_FAILURE',
  CHECK_ASSIGN_TASK_PTO_LOADING: 'CHECK_ASSIGN_TASK_PTO_LOADING',
  CHECK_ASSIGN_TASK_PTO_RESET: 'CHECK_ASSIGN_TASK_PTO_RESET',

  // 10th supervisor alert
  GET_SUPERVISOR_ALERT_REQUEST: 'GET_SUPERVISOR_ALERT_REQUEST',
  GET_SUPERVISOR_ALERT_SUCCESS: 'GET_SUPERVISOR_ALERT_SUCCESS',
  GET_SUPERVISOR_ALERT_FAILURE: 'GET_SUPERVISOR_ALERT_FAILURE',
  GET_SUPERVISOR_ALERT_LOADING: 'GET_SUPERVISOR_ALERT_LOADING',
  GET_SUPERVISOR_ALERT_RESET: 'GET_SUPERVISOR_ALERT_RESET',

  // 10th supervisor alert setting
  GET_SUPERVISOR_ALERT_REQUEST_SETTING: 'GET_SUPERVISOR_ALERT_REQUEST_SETTING',
  GET_SUPERVISOR_ALERT_SUCCESS_SETTING: 'GET_SUPERVISOR_ALERT_SUCCESS_SETTING',
  GET_SUPERVISOR_ALERT_FAILURE_SETTING: 'GET_SUPERVISOR_ALERT_FAILURE_SETTING',
  GET_SUPERVISOR_ALERT_LOADING_SETTING: 'GET_SUPERVISOR_ALERT_LOADING_SETTING',
  GET_SUPERVISOR_ALERT_RESET_SETTING: 'GET_SUPERVISOR_ALERT_RESET_SETTING',

  // Physician Signature Pending
  GET_PHYSICIAN_SIGNATURE_PENDING_REQUEST: 'GET_PHYSICIAN_SIGNATURE_PENDING_REQUEST',
  GET_PHYSICIAN_SIGNATURE_PENDING_SUCCESS: 'GET_PHYSICIAN_SIGNATURE_PENDING_SUCCESS',
  GET_PHYSICIAN_SIGNATURE_PENDING_FAILURE: 'GET_PHYSICIAN_SIGNATURE_PENDING_FAILURE',
  GET_PHYSICIAN_SIGNATURE_PENDING_LOADING: 'GET_PHYSICIAN_SIGNATURE_PENDING_LOADING',
  GET_PHYSICIAN_SIGNATURE_PENDING_RESET: 'GET_PHYSICIAN_SIGNATURE_PENDING_RESET',

  // All Physicians
  GET_ALL_PHYSICIANS_REQUEST: 'GET_ALL_PHYSICIANS_REQUEST',
  GET_ALL_PHYSICIANS_SUCCESS: 'GET_ALL_PHYSICIANS_SUCCESS',
  GET_ALL_PHYSICIANS_FAILURE: 'GET_ALL_PHYSICIANS_FAILURE',
  GET_ALL_PHYSICIANS_LOADING: 'GET_ALL_PHYSICIANS_LOADING',
  GET_ALL_PHYSICIANS_RESET: 'GET_ALL_PHYSICIANS_RESET',

  // Pending Signature Physicians (Department Dashboard signature-pending dropdown)
  GET_PENDING_SIGNATURE_PHYSICIANS_REQUEST: 'GET_PENDING_SIGNATURE_PHYSICIANS_REQUEST',
  GET_PENDING_SIGNATURE_PHYSICIANS_SUCCESS: 'GET_PENDING_SIGNATURE_PHYSICIANS_SUCCESS',
  GET_PENDING_SIGNATURE_PHYSICIANS_FAILURE: 'GET_PENDING_SIGNATURE_PHYSICIANS_FAILURE',
  GET_PENDING_SIGNATURE_PHYSICIANS_LOADING: 'GET_PENDING_SIGNATURE_PHYSICIANS_LOADING',
  GET_PENDING_SIGNATURE_PHYSICIANS_RESET: 'GET_PENDING_SIGNATURE_PHYSICIANS_RESET',
};

export const episodeOfCareAction = {
  GET_EPISODE_OF_CARE_REQUEST: 'GET_EPISODE_OF_CARE_REQUEST',
  GET_EPISODE_OF_CARE_SUCCESS: 'GET_EPISODE_OF_CARE_SUCCESS',
  GET_EPISODE_OF_CARE_FAILURE: 'GET_EPISODE_OF_CARE_FAILURE',
  ClOSE_EPISODE_OF_CARE_REQUEST: 'CLOSE_EPISODE_OF_CARE_REQUEST',
  CLOSE_EPISODE_OF_CARE_SUCCESS: 'CLOSE_EPISODE_OF_CARE_SUCCESS',
  CLOSE_EPISODE_OF_CARE_LOADING: 'CLOSE_EPISODE_OF_CARE_LOADING',
  CLOSE_EPISODE_OF_CARE_FAILURE: 'CLOSE_EPISODE_OF_CARE_FAILURE',
  RESET_CLOSE_EPISODE_OF_CARE: 'RESET_CLOSE_EPISODE_OF_CARE',
  GET_SINGLE_EPISODE_OF_CARE_REQUEST: 'GET_SINGLE_EPISODE_OF_CARE_REQUEST',
  GET_SINGLE_EPISODE_OF_CARE_SUCCESS: 'GET_GINGLE_EPISODE_OF_CARE_SUCCESS',
  GET_SINGLE_EPISODE_OF_CARE_FAILURE: 'GET_SINGLE_EPISODE_OF_CARE_FAILURE',
  CREATE_EPISODE_OF_CARE_REQUEST: 'CREATE_EPISODE_OF_CARE_REQUEST',
  CREATE_EPISODE_OF_CARE_SUCCESS: 'CREATE_EPISODE_OF_CARE_SUCCESS',
  CREATE_EPISODE_OF_CARE_FAILURE: 'CREATE_EPISODE_OF_CARE_FAILURE',
  CREATE_EPISODE_OF_CARE_LOADING: 'CREATE_EPISODE_OF_CARE_LOADING',
  RESET_CREATE_EPISODE_OF_CARE: 'RESET_CREATE_EPISODE_OF_CARE',
  EDIT_EPISODE_OF_CARE_REQUEST: 'EDIT_EPISODE_OF_CARE_REQUEST',
  EDIT_EPISODE_OF_CARE_SUCCESS: 'EDIT_EPISODE_OF_CARE_SUCCESS',
  EDIT_EPISODE_OF_CARE_FAILURE: 'EDIT_EPISODE_OF_CARE_FAILURE',
  RESET_EDIT_EPISODE_OF_CARE: 'RESET_EDIT_EPISODE_OF_CARE',
  GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_REQUEST: 'GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_REQUEST',
  GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_SUCCESS: 'GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_SUCCESS',
  GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_FAILURE: 'GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_FAILURE',
  GET_SINGLE_EPISODE_OF_CARE_LOADING: 'GET_SINGLE_EPISODE_OF_CARE_LOADING',
};

export const monthCloseOutAlertConstants = {
  GET_MONTH_CLOSE_OUT_ALERT_REQUEST: 'GET_MONTH_CLOSE_OUT_ALERT_REQUEST',
  GET_MONTH_CLOSE_OUT_ALERT_SUCCESS: 'GET_MONTH_CLOSE_OUT_ALERT_SUCCESS',
  GET_MONTH_CLOSE_OUT_ALERT_FAILURE: 'GET_MONTH_CLOSE_OUT_ALERT_FAILURE',
  GET_MONTH_CLOSE_OUT_ALERT_RESET: 'GET_MONTH_CLOSE_OUT_ALERT_RESET',
  GET_MONTH_CLOSE_OUT_ALERT_LOADING: 'GET_MONTH_CLOSE_OUT_ALERT_LOADING',

  //upload sign file
  UPLOAD_MONTH_END_ALERT_SIGN_REQUEST: 'UPLOAD_MONTH_END_ALERT_SIGN_REQUEST',
  UPLOAD_MONTH_END_ALERT_SIGN_SUCCESS: 'UPLOAD_MONTH_END_ALERT_SIGN_SUCCESS',
  UPLOAD_MONTH_END_ALERT_SIGN_FAILURE: 'UPLOAD_MONTH_END_ALERT_SIGN_FAILURE',
  UPLOAD_MONTH_END_ALERT_SIGN_LOADING: 'UPLOAD_MONTH_END_ALERT_SIGN_LOADING',
  UPLOAD_MONTH_END_ALERT_SIGN_RESET: 'UPLOAD_MONTH_END_ALERT_SIGN_RESET',

  //reopen closeout
  REOPEN_CLOSEOUT_REQUEST: 'REOPEN_CLOSEOUT_REQUEST',
  REOPEN_CLOSEOUT_SUCCESS: 'REOPEN_CLOSEOUT_SUCCESS',
  REOPEN_CLOSEOUT_FAILURE: 'REOPEN_CLOSEOUT_FAILURE',
  REOPEN_CLOSEOUT_LOADING: 'REOPEN_CLOSEOUT_LOADING',
  REOPEN_CLOSEOUT_RESET: 'REOPEN_CLOSEOUT_RESET',

  //BOPS-115 create custom closeout period
  CREATE_CUSTOM_CLOSEOUT_REQUEST: 'CREATE_CUSTOM_CLOSEOUT_REQUEST',
  CREATE_CUSTOM_CLOSEOUT_SUCCESS: 'CREATE_CUSTOM_CLOSEOUT_SUCCESS',
  CREATE_CUSTOM_CLOSEOUT_FAILURE: 'CREATE_CUSTOM_CLOSEOUT_FAILURE',
  CREATE_CUSTOM_CLOSEOUT_LOADING: 'CREATE_CUSTOM_CLOSEOUT_LOADING',
  CREATE_CUSTOM_CLOSEOUT_RESET: 'CREATE_CUSTOM_CLOSEOUT_RESET',

  //BOPS-115 edit custom closeout period dates
  UPDATE_CUSTOM_CLOSEOUT_REQUEST: 'UPDATE_CUSTOM_CLOSEOUT_REQUEST',
  UPDATE_CUSTOM_CLOSEOUT_SUCCESS: 'UPDATE_CUSTOM_CLOSEOUT_SUCCESS',
  UPDATE_CUSTOM_CLOSEOUT_FAILURE: 'UPDATE_CUSTOM_CLOSEOUT_FAILURE',
  UPDATE_CUSTOM_CLOSEOUT_LOADING: 'UPDATE_CUSTOM_CLOSEOUT_LOADING',
  UPDATE_CUSTOM_CLOSEOUT_RESET: 'UPDATE_CUSTOM_CLOSEOUT_RESET',

  //BOPS-115 cancel custom closeout period
  CANCEL_CUSTOM_CLOSEOUT_REQUEST: 'CANCEL_CUSTOM_CLOSEOUT_REQUEST',
  CANCEL_CUSTOM_CLOSEOUT_SUCCESS: 'CANCEL_CUSTOM_CLOSEOUT_SUCCESS',
  CANCEL_CUSTOM_CLOSEOUT_FAILURE: 'CANCEL_CUSTOM_CLOSEOUT_FAILURE',
  CANCEL_CUSTOM_CLOSEOUT_LOADING: 'CANCEL_CUSTOM_CLOSEOUT_LOADING',
  CANCEL_CUSTOM_CLOSEOUT_RESET: 'CANCEL_CUSTOM_CLOSEOUT_RESET',
};

export const monthEndAlertConstants = {
  GET_MONTH_END_ALERTS_COUNT_REQUEST: 'GET_MONTH_END_ALERTS_COUNT_REQUEST',
  GET_MONTH_END_ALERTS_COUNT_SUCCESS: 'GET_MONTH_END_ALERTS_SUCCESS',
  GET_MONTH_END_ALERTS_COUNT_FAILURE: 'GET_MONTH_END_ALERTS_FAILURE',
  GET_CURRENT_MONTH_ALERT_COUNT_SUCCESS: 'GET_CURRENT_MONTH_ALERT_COUNT_SUCCESS',

  GET_THEME_COUNT_REQUEST: 'GET_THEME_COUNT_REQUEST',
  GET_THEME_COUNT_SUCCESS: 'GET_THEME_SUCCESS',
  GET_THEME_COUNT_FAILURE: 'GET_THEME_FAILURE',

  GET_OWNER_ALERT_COUNT_REQUEST: 'GET_OWNER_ALERT_COUNT_REQUEST',
  GET_OWNER_ALERT_COUNT_SUCCESS: 'GET_OWNER_ALERT_SUCCESS',
  GET_OWNER_ALERT_COUNT_FAILURE: 'GET_OWNER_ALERT_FAILURE',

  GET_LIST_OF_MONTH_REQUEST: 'GET_LIST_OF_MONTH_REQUEST',
  GET_LIST_OF_MONTH_SUCCESS: 'GET_LIST_OF_MONTH_SUCCESS',
  GET_LIST_OF_MONTH_FAILURE: 'GET_LIST_OF_MONTH_FAILURE',
  REQUEST_CERTIFY_ALERT: 'REQUEST_CERTIFY_ALERT',
  SUCCESS_CERTIFY_ALERT: 'SUCCESS_CERTIFY_ALERT',
  FAILURE_CERTIFY_ALERT: 'FAILURE_CERTIFY_ALERT',
  RESET_CERTIFY_ALERT: 'RESET_CERTIFY_ALERT',
  LOADING_CERTIFY_ALERT: 'LOADING_CERTIFY_ALERT',

  REQUEST_GET_STATUS_CERTIFY: 'REQUEST_GET_STATUS_CERTIFY',
  SUCCESS_GET_STATUS_CERTIFY: 'SUCCESS_GET_STATUS_CERTIFY',
  FAILURE_GET_STATUS_CERTIFY: 'FAILURE_GET_STATUS_CERTIFY',
  LOADING_GET_STATUS_CERTIFY: 'LOADING_GET_STATUS_CERTIFY',
};

export const getMyAvailabilityConstants = {
  GET_MY_AVAILABILITY_REQUEST: 'GET_MY_AVAILABILITY_REQUEST',
  GET_MY_AVAILABILITY_SUCCESS: 'GET_MY_AVAILABILITY_SUCCESS',
  GET_MY_AVAILABILITY_FAILURE: 'GET_MY_AVAILABILITY_FAILURE',
  GET_MY_AVAILABILITY_RESET: 'GET_MY_AVAILABILITY_RESET',
  GET_MY_AVAILABILITY_LOADING: 'GET_MY_AVAILABILITY_LOADING',
  GET_ALL_PTO_REQUEST: 'GET_ALL_PTO_REQUEST',
  GET_ALL_PTO_SUCCESS: 'GET_ALL_PTO_SUCCESS',
  GET_ALL_PTO_FAILURE: 'GET_ALL_PTO_FAILURE',
  CREATE_PTO_REQUEST_REQUEST: 'CREATE_PTO_REQUEST_REQUEST',
  CREATE_PTO_SUCCESS_REQUEST: 'CREATE_PTO_SUCCESS_REQUEST',
  CREATE_PTO_FAILURE_REQUEST: 'CREATE_PTO_FAILURE_REQUEST',
  CREATE_PTO_RESET_REQUEST: 'CREATE_PTO_RESET_REQUEST',
  REMOVE_PTO_REQ_REQUEST: 'REMOVE_PTO_REQ_REQUEST',
  REMOVE_PTO_REQ_SUCCESS: 'REMOVE_PTO_REQ_SUCCESS',
  REMOVE_PTO_REQ_FAILURE: 'REMOVE_PTO_REQ_FAILURE',
  REMOVE_PTO_REQ_RESET: 'REMOVE_PTO_REQ_RESET',
  REMOVE_PTO_REQ_LOADER: 'REMOVE_PTO_REQ_LOADER',
  EDIT_MY_AVAILABILITY_REQUEST: 'EDIT_MY_AVAILABILITY_REQUEST',
  EDIT_MY_AVAILABILITY_SUCCESS: 'EDIT_MY_AVAILABILITY_SUCCESS',
  EDIT_MY_AVAILABILITY_FAILURE: 'EDIT_MY_AVAILABILITY_FAILURE',
  EDIT_MY_AVAILABILITY_RESET: 'EDIT_MY_AVAILABILITY_RESET',
  EDIT_MY_AVAILABILITY_LOADING: 'EDIT_MY_AVAILABILITY_LOADING',

  GET_LIST_OF_THERAPIST_AVA_REQUEST: 'GET_LIST_OF_THERAPIST_AVA_REQUEST',
  GET_LIST_OF_THERAPIST_AVA_SUCCESS: 'GET_LIST_OF_THERAPIST_AVA_SUCCESS',
  GET_LIST_OF_THERAPIST_AVA_FAILURE: 'GET_LIST_OF_THERAPIST_AVA_FAILURE',
  GET_LIST_OF_THERAPIST_AVA_LOADING: 'GET_LIST_OF_THERAPIST_AVA_LOADING',
  GET_LIST_OF_THERAPIST_AVA_RESET: 'GET_LIST_OF_THERAPIST_AVA_RESET',
};

export const laborHoursConstant = {
  GET_LABOR_HOURS_REQUEST: 'GET_LABOR_HOURS_REQUEST',
  GET_LABOR_HOURS_LOADER: 'GET_LABOR_HOURS_LOADER',
  GET_LABOR_HOURS_SUCCESS: 'GET_LABOR_HOURS_SUCCESS',
  GET_LABOR_HOURS_FAILURE: 'GET_LABOR_HOURS_FAILURE',
  GET_LABOR_HOURS_RESET: 'GET_LABOR_HOURS_RESET',

  GET_LABOR_CODES_REQUEST: 'GET_LABOR_CODES_REQUEST',
  GET_LABOR_CODES_SUCCESS: 'GET_LABOR_CODES_SUCCESS',
  GET_LABOR_CODES_FAILURE: 'GET_LABOR_CODES_FAILURE',

  ADD_LABOR_HOURS_REQUEST: 'ADD_LABOR_HOURS_REQUEST',
  ADD_LABOR_HOURS_LOADER: 'ADD_LABOR_HOURS_LOADER',
  ADD_LABOR_HOURS_SUCCESS: 'ADD_LABOR_HOURS_SUCCESS',
  ADD_LABOR_HOURS_FAILURE: 'ADD_LABOR_HOURS_FAILURE',
  ADD_LABOR_HOURS_RESET: 'ADD_LABOR_HOURS_RESET',

  EDIT_LABOR_HOURS_REQUEST: 'EDIT_LABOR_HOURS_REQUEST',
  EDIT_LABOR_HOURS_LOADER: 'EDIT_LABOR_HOURS_LOADER',
  EDIT_LABOR_HOURS_SUCCESS: 'EDIT_LABOR_HOURS_SUCCESS',
  EDIT_LABOR_HOURS_FAILURE: 'EDIT_LABOR_HOURS_FAILURE',
  EDIT_LABOR_HOURS_RESET: 'EDIT_LABOR_HOURS_RESET',

  GET_LOCATION_TYPE_REQUEST: 'GET_LOCATION_TYPE_REQUEST',
  GET_LOCATION_TYPE_SUCCESS: 'GET_LOCATION_TYPE_SUCCESS',
  GET_LOCATION_TYPE_FAILURE: 'GET_LOCATION_TYPE_FAILURE',
  GET_LOCATION_TYPE_LOADER: 'GET_LOCATION_TYPE_LOADER',

  DELETE_LABOR_HOURS_REQUEST: 'DELETE_LABOR_HOURS_REQUEST',
  DELETE_LABOR_HOURS_LOADER: 'DELETE_LABOR_HOURS_LOADER',
  DELETE_LABOR_HOURS_SUCCESS: 'DELETE_LABOR_HOURS_SUCCESS',
  DELETE_LABOR_HOURS_FAILURE: 'DELETE_LABOR_HOURS_FAILURE',
  DELETE_LABOR_HOURS_RESET: 'DELETE_LABOR_HOURS_RESET',

  GET_LABOR_REPORT_REQUEST: 'GET_LABOR_REPORT_REQUEST',
  GET_LABOR_REPORT_LOADER: 'GET_LABOR_REPORT_LOADER',
  GET_LABOR_REPORT_SUCCESS: 'GET_LABOR_REPORT_SUCCESS',
  GET_LABOR_REPORT_FAILURE: 'GET_LABOR_REPORT_FAILURE',
  GET_LABOR_REPORT_RESET: 'GET_LABOR_REPORT_RESET',

  GET_BUILDINGS_OVERVIEW_REQUEST: 'GET_BUILDINGS_OVERVIEW_REQUEST',
  GET_BUILDINGS_OVERVIEW_LOADER: 'GET_BUILDINGS_OVERVIEW_LOADER',
  GET_BUILDINGS_OVERVIEW_SUCCESS: 'GET_BUILDINGS_OVERVIEW_SUCCESS',
  GET_BUILDINGS_OVERVIEW_FAILURE: 'GET_BUILDINGS_OVERVIEW_FAILURE',
  GET_BUILDINGS_OVERVIEW_RESET: 'GET_BUILDINGS_OVERVIEW_RESET',

  GET_LABOR_ENTRY_HISTORY_REQUEST: 'GET_LABOR_ENTRY_HISTORY_REQUEST',
  GET_LABOR_ENTRY_HISTORY_LOADER: 'GET_LABOR_ENTRY_HISTORY_LOADER',
  GET_LABOR_ENTRY_HISTORY_SUCCESS: 'GET_LABOR_ENTRY_HISTORY_SUCCESS',
  GET_LABOR_ENTRY_HISTORY_FAILURE: 'GET_LABOR_ENTRY_HISTORY_FAILURE',
  GET_LABOR_ENTRY_HISTORY_RESET: 'GET_LABOR_ENTRY_HISTORY_RESET',

  UPDATE_LABOR_ENTRY_STATUS_REQUEST: 'UPDATE_LABOR_ENTRY_STATUS_REQUEST',
  UPDATE_LABOR_ENTRY_STATUS_LOADER: 'UPDATE_LABOR_ENTRY_STATUS_LOADER',
  UPDATE_LABOR_ENTRY_STATUS_SUCCESS: 'UPDATE_LABOR_ENTRY_STATUS_SUCCESS',
  UPDATE_LABOR_ENTRY_STATUS_FAILURE: 'UPDATE_LABOR_ENTRY_STATUS_FAILURE',
  UPDATE_LABOR_ENTRY_STATUS_RESET: 'UPDATE_LABOR_ENTRY_STATUS_RESET',

  GET_LABOR_VALIDATION_TOGGLE_REQUEST: 'GET_LABOR_VALIDATION_TOGGLE_REQUEST',
  GET_LABOR_VALIDATION_TOGGLE_LOADER: 'GET_LABOR_VALIDATION_TOGGLE_LOADER',
  GET_LABOR_VALIDATION_TOGGLE_SUCCESS: 'GET_LABOR_VALIDATION_TOGGLE_SUCCESS',
  GET_LABOR_VALIDATION_TOGGLE_FAILURE: 'GET_LABOR_VALIDATION_TOGGLE_FAILURE',
  GET_LABOR_VALIDATION_TOGGLE_RESET: 'GET_LABOR_VALIDATION_TOGGLE_RESET',

  GET_PAY_PERIOD_BY_DATE_REQUEST: 'GET_PAY_PERIOD_BY_DATE_REQUEST',
  GET_PAY_PERIOD_BY_DATE_LOADER: 'GET_PAY_PERIOD_BY_DATE_LOADER',
  GET_PAY_PERIOD_BY_DATE_SUCCESS: 'GET_PAY_PERIOD_BY_DATE_SUCCESS',
  GET_PAY_PERIOD_BY_DATE_FAILURE: 'GET_PAY_PERIOD_BY_DATE_FAILURE',
  GET_PAY_PERIOD_BY_DATE_RESET: 'GET_PAY_PERIOD_BY_DATE_RESET',
  APPROVE_PAY_PERIOD_REQUEST: 'APPROVE_PAY_PERIOD_REQUEST',
  APPROVE_PAY_PERIOD_LOADER: 'APPROVE_PAY_PERIOD_LOADER',
  APPROVE_PAY_PERIOD_SUCCESS: 'APPROVE_PAY_PERIOD_SUCCESS',
  APPROVE_PAY_PERIOD_FAILURE: 'APPROVE_PAY_PERIOD_FAILURE',
  APPROVE_PAY_PERIOD_RESET: 'APPROVE_PAY_PERIOD_RESET',
  GET_PAY_PERIOD_CYCLES_REQUEST: 'GET_PAY_PERIOD_CYCLES_REQUEST',
  GET_PAY_PERIOD_CYCLES_LOADER: 'GET_PAY_PERIOD_CYCLES_LOADER',
  GET_PAY_PERIOD_CYCLES_SUCCESS: 'GET_PAY_PERIOD_CYCLES_SUCCESS',
  GET_PAY_PERIOD_CYCLES_FAILURE: 'GET_PAY_PERIOD_CYCLES_FAILURE',
  GET_PAY_PERIOD_CYCLES_RESET: 'GET_PAY_PERIOD_CYCLES_RESET',
};

export const npcLogConstant = {
  GET_NPC_ENTRIES_REQUEST: 'GET_NPC_ENTRIES_REQUEST',
  GET_NPC_ENTRIES_LOADER: 'GET_NPC_ENTRIES_LOADER',
  GET_NPC_ENTRIES_SUCCESS: 'GET_NPC_ENTRIES_SUCCESS',
  GET_NPC_ENTRIES_FAILURE: 'GET_NPC_ENTRIES_FAILURE',
  GET_NPC_ENTRIES_RESET: 'GET_NPC_ENTRIES_RESET',

  GET_NPC_ACTIVITY_TYPES_REQUEST: 'GET_NPC_ACTIVITY_TYPES_REQUEST',
  GET_NPC_ACTIVITY_TYPES_LOADER: 'GET_NPC_ACTIVITY_TYPES_LOADER',
  GET_NPC_ACTIVITY_TYPES_SUCCESS: 'GET_NPC_ACTIVITY_TYPES_SUCCESS',
  GET_NPC_ACTIVITY_TYPES_FAILURE: 'GET_NPC_ACTIVITY_TYPES_FAILURE',

  ADD_NPC_ENTRY_REQUEST: 'ADD_NPC_ENTRY_REQUEST',
  ADD_NPC_ENTRY_LOADER: 'ADD_NPC_ENTRY_LOADER',
  ADD_NPC_ENTRY_SUCCESS: 'ADD_NPC_ENTRY_SUCCESS',
  ADD_NPC_ENTRY_FAILURE: 'ADD_NPC_ENTRY_FAILURE',
  ADD_NPC_ENTRY_RESET: 'ADD_NPC_ENTRY_RESET',

  EDIT_NPC_ENTRY_REQUEST: 'EDIT_NPC_ENTRY_REQUEST',
  EDIT_NPC_ENTRY_LOADER: 'EDIT_NPC_ENTRY_LOADER',
  EDIT_NPC_ENTRY_SUCCESS: 'EDIT_NPC_ENTRY_SUCCESS',
  EDIT_NPC_ENTRY_FAILURE: 'EDIT_NPC_ENTRY_FAILURE',
  EDIT_NPC_ENTRY_RESET: 'EDIT_NPC_ENTRY_RESET',

  DELETE_NPC_ENTRY_REQUEST: 'DELETE_NPC_ENTRY_REQUEST',
  DELETE_NPC_ENTRY_LOADER: 'DELETE_NPC_ENTRY_LOADER',
  DELETE_NPC_ENTRY_SUCCESS: 'DELETE_NPC_ENTRY_SUCCESS',
  DELETE_NPC_ENTRY_FAILURE: 'DELETE_NPC_ENTRY_FAILURE',
  DELETE_NPC_ENTRY_RESET: 'DELETE_NPC_ENTRY_RESET',

  // Reviewer surface (THIN-7742)
  GET_NPC_TEAM_ENTRIES_REQUEST: 'GET_NPC_TEAM_ENTRIES_REQUEST',
  GET_NPC_TEAM_ENTRIES_LOADER: 'GET_NPC_TEAM_ENTRIES_LOADER',
  GET_NPC_TEAM_ENTRIES_SUCCESS: 'GET_NPC_TEAM_ENTRIES_SUCCESS',
  GET_NPC_TEAM_ENTRIES_FAILURE: 'GET_NPC_TEAM_ENTRIES_FAILURE',
  GET_NPC_TEAM_ENTRIES_RESET: 'GET_NPC_TEAM_ENTRIES_RESET',

  // THIN-8330: reviewer surface for a user who also holds EDIT_TEAM_NPC. Same payload shape and
  // endpoint as GET_NPC_TEAM_ENTRIES, kept as its own action/reducer/saga.
  GET_NPC_TEAM_ENTRIES_EDITABLE_REQUEST: 'GET_NPC_TEAM_ENTRIES_EDITABLE_REQUEST',
  GET_NPC_TEAM_ENTRIES_EDITABLE_LOADER: 'GET_NPC_TEAM_ENTRIES_EDITABLE_LOADER',
  GET_NPC_TEAM_ENTRIES_EDITABLE_SUCCESS: 'GET_NPC_TEAM_ENTRIES_EDITABLE_SUCCESS',
  GET_NPC_TEAM_ENTRIES_EDITABLE_FAILURE: 'GET_NPC_TEAM_ENTRIES_EDITABLE_FAILURE',
  GET_NPC_TEAM_ENTRIES_EDITABLE_RESET: 'GET_NPC_TEAM_ENTRIES_EDITABLE_RESET',

  REVIEW_NPC_ENTRY_REQUEST: 'REVIEW_NPC_ENTRY_REQUEST',
  REVIEW_NPC_ENTRY_LOADER: 'REVIEW_NPC_ENTRY_LOADER',
  REVIEW_NPC_ENTRY_SUCCESS: 'REVIEW_NPC_ENTRY_SUCCESS',
  REVIEW_NPC_ENTRY_FAILURE: 'REVIEW_NPC_ENTRY_FAILURE',
  REVIEW_NPC_ENTRY_RESET: 'REVIEW_NPC_ENTRY_RESET',
};

export const addTaskConstant = {
  ADD_TASK_THERAPIST_REQUEST: 'ADD_TASK_THERAPIST_REQUEST',
  ADD_TASK_THERAPIST_SUCCESS: 'ADD_TASK_THERAPIST_SUCCESS',
  ADD_TASK_THERAPIST_FAILURE: 'ADD_TASK_THERAPIST_FAILURE',
  ADD_TASK_THERAPIST_RESET: 'ADD_TASK_THERAPIST_RESET',
  ADD_TASK_THERAPIST_LOADING: 'ADD_TASK_THERAPIST_LOADING',

  GET_TASK_AVAILABILITY_REQUEST: 'GET_TASK_AVAILABILITY_REQUEST',
  GET_TASK_AVAILABILITY_SUCCESS: 'GET_TASK_AVAILABILITY_SUCCESS',
  GET_TASK_AVAILABILITY_FAILURE: 'GET_TASK_AVAILABILITY_FAILURE',
  GET_TASK_AVAILABILITY_RESET: 'GET_TASK_AVAILABILITY_RESET',
  GET_TASK_AVAILABILITY_LOADING: 'GET_TASK_AVAILABILITY_LOADING',
};

export const unlockTherapistConstant = {
  GET_UNLOCK_THERAPIST_REQUEST: 'GET_UNLOCK_THERAPIST_REQUEST',
  GET_UNLOCK_THERAPIST_SUCCESS: 'GET_UNLOCK_THERAPIST_SUCCESS',
  GET_UNLOCK_THERAPIST_FAILURE: 'GET_UNLOCK_THERAPIST_FAILURE',
  GET_UNLOCK_THERAPIST_RESET: 'GET_UNLOCK_THERAPIST_RESET',
  GET_UNLOCK_THERAPIST_LOADING: 'GET_UNLOCK_THERAPIST_LOADING',

  //update unlock therapist
  POST_UNLOCK_THERAPIST_REQUEST: 'POST_UNLOCK_THERAPIST_REQUEST',
  POST_UNLOCK_THERAPIST_SUCCESS: 'POST_UNLOCK_THERAPIST_SUCCESS',
  POST_UNLOCK_THERAPIST_FAILURE: 'POST_UNLOCK_THERAPIST_FAILURE',
  POST_UNLOCK_THERAPIST_RESET: 'POST_UNLOCK_THERAPIST_RESET',
  POST_UNLOCK_THERAPIST_LOADING: 'POST_UNLOCK_THERAPIST_LOADING',

  //lock daily session notes
  GET_LOCK_DAILY_SESSION_NOTES_REQUEST: 'GET_LOCK_DAILY_SESSION_NOTES_REQUEST',
  GET_LOCK_DAILY_SESSION_NOTES_SUCCESS: 'GET_LOCK_DAILY_SESSION_NOTES_SUCCESS',
  GET_LOCK_DAILY_SESSION_NOTES_FAILURE: 'GET_LOCK_DAILY_SESSION_NOTES_FAILURE',
  GET_LOCK_DAILY_SESSION_NOTES_RESET: 'GET_LOCK_DAILY_SESSION_NOTES_RESET',
  GET_LOCK_DAILY_SESSION_NOTES_LOADING: 'GET_LOCK_DAILY_SESSION_NOTES_LOADING',
};

export const editTaskConstant = {
  EDIT_TASK_THERAPIST_SCHEDULING_REQUEST: 'EDIT_TASK_THERAPIST_SCHEDULING_REQUEST',
  EDIT_TASK_THERAPIST_SCHEDULING_SUCCESS: 'EDIT_TASK_THERAPIST_SCHEDULING_SUCCESS',
  EDIT_TASK_THERAPIST_SCHEDULING_FAILURE: 'EDIT_TASK_THERAPIST_SCHEDULING_FAILURE',
  EDIT_TASK_THERAPIST_SCHEDULING_RESET: 'EDIT_TASK_THERAPIST_SCHEDULING_RESET',
  EDIT_TASK_THERAPIST_SCHEDULING_LOADING: 'EDIT_TASK_THERAPIST_SCHEDULING_LOADING',
};

export const skillListConstant = {
  GET_SKILL_THERAPIST_SCHEDULING_LIST_REQUEST: 'GET_SKILL_THERAPIST_SCHEDULING_LIST_REQUEST',
  GET_SKILL_THERAPIST_SCHEDULING_LIST_SUCCESS: 'GET_SKILL_THERAPIST_SCHEDULING_LIST_SUCCESS',
  GET_SKILL_THERAPIST_SCHEDULING_LIST_FAILURE: 'GET_SKILL_THERAPIST_SCHEDULING_LIST_FAILURE',
};
export const patientDateOfServiceConstant = {
  GET_PATIENT_DATE_OF_SERVICE_REQUEST: 'GET_PATIENT_DATE_OF_SERVICE_REQUEST',
  GET_PATIENT_DATE_OF_SERVICE_SUCCESS: 'GET_PATIENT_DATE_OF_SERVICE_SUCCESS',
  GET_PATIENT_DATE_OF_SERVICE_FAILURE: 'GET_PATIENT_DATE_OF_SERVICE_FAILURE',
};

export const therapistDisciplineList = {
  GET_THERAPIST_DISCIPLINE_LIST_REQUEST: 'GET_THERAPIST_DISCIPLINE_LIST_REQUEST',
  GET_THERAPIST_DISCIPLINE_LIST_SUCCESS: 'GET_THERAPIST_DISCIPLINE_LIST_SUCCESS',
  GET_THERAPIST_DISCIPLINE_LIST_FAILURE: 'GET_THERAPIST_DISCIPLINE_LIST_FAILURE',
};

export const documentationActions = {
  REQUEST_GET_ALL_TEMPLATES: 'REQUEST_GET_ALL_TEMPLATES',
  SUCCESS_GET_ALL_TEMPLATES: 'SUCCESS_GET_ALL_TEMPLATES',
  FAILURE_GET_ALL_TEMPLATES: 'FAILURE_GET_ALL_TEMPLATES',
  SUCCESS_CALL_SUBMISSION_EVENT: 'SUCCESS_CALL_SUBMISSION_EVENT',
  FAILURE_CALL_SUBMISSION_EVENT: 'FAILURE_CALL_SUBMISSION_EVENT',
  RESET_CALL_SUBMISSION_EVENT: 'RESET_CALL_SUBMISSION_EVENT',
  REQUEST_ASSIGN_SUPERVISOR: 'REQUEST_ASSIGN_SUPERVISOR',
  REQUEST_ASSIGN_PHYSICIAN: 'REQUEST_ASSIGN_PHYSICIAN',
  REQUEST_GET_ALL_SUBMITTED_DOCUMENT: 'REQUEST_GET_ALL_SUBMITTED_DOCUMENT',
  REQUEST_GET_ALL_SUBMITTED_DOCUMENT_FOR_RESOLVER:
    'REQUEST_GET_ALL_SUBMITTED_DOCUMENT_FOR_RESOLVER',
  SUCCESS_GET_ALL_SUBMITTED_DOCUMENT: 'SUCCESS_GET_ALL_SUBMITTED_DOCUMENT',
  FAILURE_GET_ALL_SUBMITTED_DOCUMENT: 'FAILURE_GET_ALL_SUBMITTED_DOCUMENT',
  RESET_GET_ALL_SUBMITTED_DOCUMENT: 'RESET_GET_ALL_SUBMITTED_DOCUMENT',
  LOADER_GET_ALL_SUBMITTED_DOCUMENT: 'LOADER_GET_ALL_SUBMITTED_DOCUMENT',

  FAILURE_GET_ALL_COMPETED_DOCUMENT: 'FAILURE_GET_ALL_COMPETED_DOCUMENT',
  SUCCESS_GET_ALL_COMPETED_DOCUMENT: 'SUCCESS_GET_ALL_COMPETED_DOCUMENT',
  RESET_GET_ALL_COMPETED_DOCUMENT: 'RESET_GET_ALL_COMPETED_DOCUMENT',
  LOADER_GET_ALL_COMPETED_DOCUMENT: 'LOADER_GET_ALL_COMPETED_DOCUMENT',
  REQUEST_GET_ALL_COMPETED_DOCUMENT: 'REQUEST_GET_ALL_COMPETED_DOCUMENT',

  REQUEST_SUBMITTED_DATA_BY_SUBMISSION_ID: 'REQUEST_SUBMITTED_DATA_BY_SUBMISSION_ID',
  SUCCESS_SUBMITTED_DATA_BY_SUBMISSION_ID: 'SUCCESS_SUBMITTED_DATA_BY_SUBMISSION_ID',
  FAILURE_SUBMITTED_DATA_BY_SUBMISSION_ID: 'FAILURE_SUBMITTED_DATA_BY_SUBMISSION_ID',
  RESET_SUBMITTED_DATA_BY_SUBMISSION_ID: 'RESET_SUBMITTED_DATA_BY_SUBMISSION_ID',
  LOADING_SUBMITTED_DATA_BY_SUBMISSION_ID: 'LOADING_SUBMITTED_DATA_BY_SUBMISSION_ID',

  REQUEST_GET_SUBMISSION_DOCUMENT: 'REQUEST_GET_SUBMISSION_DOCUMENT',
  SUCCESS_GET_SUBMISSION_DOCUMENT: 'SUCCESS_GET_SUBMISSION_DOCUMENT',
  FAILURE_GET_SUBMISSION_DOCUMENT: 'FAILURE_GET_SUBMISSION_DOCUMENT',
  LOADING_GET_SUBMISSION_DOCUMENT: 'LOADING_GET_SUBMISSION_DOCUMENT',
  RESET_GET_SUBMISSION_DOCUMENT: 'RESET_GET_SUBMISSION_DOCUMENT',
  REQUEST_GET_SIGNATURE_TEMPLATE: 'REQUEST_GET_SIGNATURE_TEMPLATE',
  SUCCESS_GET_SIGNATURE_TEMPLATE: 'SUCCESS_GET_SIGNATURE_TEMPLATE',
  FAILURE_GET_SIGNATURE_TEMPLATE: 'FAILURE_GET_SIGNATURE_TEMPLATE',
  DASHBOARD_SIGNATURE_TEMPLATE: 'DASHBOARD_SIGNATURE_TEMPLATE',
  DASHBOARD_DOC_PREVIEW: 'DASHBOARD_DOC_PREVIEW',
  RESET_GET_SIGNATURE_TEMPLATE: 'RESET_GET_SIGNATURE_TEMPLATE',
  REQUEST_GET_ALL_MISCELLANEOUS_DOCUMENTS: 'REQUEST_GET_ALL_MISCELLANEOUS_DOCUMENTS',
  SUCCESS_GET_ALL_MISCELLANEOUS_DOCUMENTS: 'SUCCESS_GET_ALL_MISCELLANEOUS_DOCUMENTS',
  FAILURE_GET_ALL_MISCELLANEOUS_DOCUMENTS: 'FAILURE_GET_ALL_MISCELLANEOUS_DOCUMENTS',
  LOADING_GET_ALL_MISCELLANEOUS_DOCUMENTS: 'LOADING_GET_ALL_MISCELLANEOUS_DOCUMENTS',
  REQUEST_SAVE_MISCELLANEOUS_DOCUMENTS: 'REQUEST_SAVE_MISCELLANEOUS_DOCUMENTS',
  SUCCESS_SAVE_MISCELLANEOUS_DOCUMENTS: 'SUCCESS_SAVE_MISCELLANEOUS_DOCUMENTS',
  FAILURE_SAVE_MISCELLANEOUS_DOCUMENTS: 'FAILURE_SAVE_MISCELLANEOUS_DOCUMENTS',
  RESET_SAVE_MISCELLANEOUS_DOCUMENTS: 'RESET_SAVE_MISCELLANEOUS_DOCUMENTS',
  LOADING_SAVE_MISCELLANEOUS_DOCUMENTS: 'LOADING_SAVE_MISCELLANEOUS_DOCUMENTS',
  REQUEST_GET_ALL_SUPERVISIORS: 'REQUEST_GET_ALL_SUPERVISIORS',
  SUCCESS_GET_ALL_SUPERVISIORS: 'SUCCESS_GET_ALL_SUPERVISIORS',
  FAILURE_GET_ALL_SUPERVISIORS: 'FAILURE_GET_ALL_SUPERVISIORS',
  LOADING_GET_ALL_SUPERVISIORS: 'LOADING_GET_ALL_SUPERVISIORS',
  LOADING_SAVE_SUBMISSION: 'LOADING_SAVE_SUBMISSION',
  REQUEST_SEND_MAIL_TO_PHYSICIAN: 'REQUEST_SEND_MAIL_TO_PHYSICIAN',
  SUCCESS_SEND_MAIL_TO_PHYSICIAN: 'SUCCESS_SEND_MAIL_TO_PHYSICIAN',
  FAILURE_SEND_MAIL_TO_PHYSICIAN: 'FAILURE_SEND_MAIL_TO_PHYSICIAN',
  RESET_SEND_MAIL_TO_PHYSICIAN: 'RESET_SEND_MAIL_TO_PHYSICIAN',
  LOADING_SEND_MAIL_TO_PHYSICIAN: 'LOADING_SEND_MAIL_TO_PHYSICIAN',
  REQUEST_GET_ALL_CODES: 'REQUEST_GET_ALL_CODES',
  SUCCESS_GET_ALL_CODES: 'SUCCESS_GET_ALL_CODES',
  FAILURE_GET_ALL_CODES: 'FAILURE_GET_ALL_CODES',
  LOADING_GET_ALL_CODES: 'LOADING_GET_ALL_CODES',
  REQUEST_GET_SIGNATURE_ACCESS: 'REQUEST_GET_SIGNATURE_ACCESS',
  SUCCESS_GET_SIGNATURE_ACCESS: 'SUCCESS_GET_SIGNATURE_ACCESS',
  FAILURE_GET_SIGNATURE_ACCESS: 'FAILURE_GET_SIGNATURE_ACCESS',
  RESET_GET_SIGNATURE_ACCESS: 'RESET_GET_SIGNATURE_ACCESS',
  REQUEST_GET_TARGET_SIGNATURE_ACCESS: 'REQUEST_GET_TARGET_SIGNATURE_ACCESS',
  SUCCESS_GET_TARGET_SIGNATURE_ACCESS: 'SUCCESS_GET_TARGET_SIGNATURE_ACCESS',
  FAILURE_GET_TARGET_SIGNATURE_ACCESS: 'FAILURE_GET_TARGET_SIGNATURE_ACCESS',
  RESET_GET_TARGET_SIGNATURE_ACCESS: 'RESET_GET_TARGET_SIGNATURE_ACCESS',
  REQUEST_GET_ALL_CODES_ICD: 'REQUEST_GET_ALL_CODES_ICD',
  SUCCESS_GET_ALL_CODES_ICD: 'SUCCESS_GET_ALL_CODES_ICD',
  FAILURE_GET_ALL_CODES_ICD: 'FAILURE_GET_ALL_CODES_ICD',
  LOADING_GET_ALL_CODES_ICD: 'LOADING_GET_ALL_CODES_ICD',
  PULL_UUID_REQUEST: 'PULL_UUID_REQUEST',
  PULL_UUID_SUCCESS: 'PULL_UUID_SUCCESS',
  PULL_UUID_FAILURE: 'PULL_UUID_FAILURE',
  PULL_UUID_LOADER: 'PULL_UUID_LOADER',
  PULL_UUID_RESET: 'PULL_UUID_RESET',
  REQUEST_REASSIGN_THERAPIST: 'REQUEST_REASSIGN_THERAPIST',
  SUCCESS_REASSIGN_THERAPIST: 'SUCCESS_REASSIGN_THERAPIST',
  FAILURE_REASSIGN_THERAPIST: 'FAILURE_REASSIGN_THERAPIST',
  LOADING_REASSIGN_THERAPIST: 'LOADING_REASSIGN_THERAPIST',
  RESET_REASSIGN_THERAPIST: 'RESET_REASSIGN_THERAPIST',
  REQUEST_GET_PROVIDER_LIST: 'REQUEST_GET_PROVIDER_LIST',
  SUCCESS_GET_PROVIDER_LIST: 'SUCCESS_GET_PROVIDER_LIST',
  FAILURE_GET_PROVIDER_LIST: 'FAILURE_GET_PROVIDER_LIST',
  LOADING_GET_PROVIDER_LIST: 'LOADING_GET_PROVIDER_LIST',
  REQUEST_LOADING_DOCUMENTATION: 'REQUEST_LOADING_DOCUMENTATION',
  SUCCESS_LOADING_DOCUMENTATION: 'SUCCESS_LOADING_DOCUMENTATION',
  ERROR_LOADING_DOCUMENTATION: 'ERROR_LOADING_DOCUMENTATION',
  RESET_LOADING_DOCUMENTATION: 'RESET_LOADING_DOCUMENTATION',

  //check daily session notes sign
  REQUEST_DAILY_SESSION_NOTES_SIGN: 'REQUEST_DAILY_SESSION_NOTES_SIGN',
  SUCCESS_DAILY_SESSION_NOTES_SIGN: 'SUCCESS_DAILY_SESSION_NOTES_SIGN',
  FAILURE_DAILY_SESSION_NOTES_SIGN: 'FAILURE_DAILY_SESSION_NOTES_SIGN',
  LOADER_DAILY_SESSION_NOTES_SIGN: 'LOADER_DAILY_SESSION_NOTES_SIGN',
  RESET_DAILY_SESSION_NOTES_SIGN: 'RESET_DAILY_SESSION_NOTES_SIGN',

  REQUEST_DELETE_REQUIRED_DOCUMET: 'REQUEST_DELETE_REQUIRED_DOCUMET',
  SUCCESS_DELETE_REQUIRED_DOCUMET: 'SUCCESS_DELETE_REQUIRED_DOCUMET',
  FAILURE_DELETE_REQUIRED_DOCUMET: 'FAILURE_DELETE_REQUIRED_DOCUMET',
  RESET_DELETE_REQUIRED_DOCUMET: 'RESET_DELETE_REQUIRED_DOCUMET',

  REQUEST_PREPARE_PROGREE_NOTE: 'REQUEST_PREPARE_PROGREE_NOTE',
  SUCCESS_PREPARE_PROGREE_NOTE: 'SUCCESS_PREPARE_PROGREE_NOTE',
  FAILURE_PREPARE_PROGREE_NOTE: 'FAILURE_PREPARE_PROGREE_NOTE',
  RESET_PREPARE_PROGREE_NOTE: 'RESET_PREPARE_PROGREE_NOTE',

  //navigation prevent
  SET_NAVIGATION_FORM: 'SET_NAVIGATION_FORM',
  RESET_NAVIGATION_FORM: 'RESET_NAVIGATION_FORM',

  GET_DASHBOARD_DOCUMENT_DATA: 'GET_DASHBOARD_DOCUMENT_DATA',
  RESET_DASHBOARD_DOCUMENT_DATA: 'RESET_DASHBOARD_DOCUMENT_DATA',

  GET_EOC_CREATE_DOCUMENT_DATA: 'GET_EOC_CREATE_DOCUMENT_DATA',
  RESET_EOC_CREATE_DOCUMENT_DATA: 'RESET_EOC_CREATE_DOCUMENT_DATA',

  GET_EOC_EDIT_DOCUMENT_DATA: 'GET_EOC_EDIT_DOCUMENT_DATA',
  RESET_EOC_EDIT_DOCUMENT_DATA: 'RESET_EOC_EDIT_DOCUMENT_DATA',

  //check is reform
  IS_CHECK_DOCUMENT_REFORM: 'IS_CHECK_DOCUMENT_REFORM',

  //check discharge
  CHECK_DISCHARGE_ALLOWS_REQUEST: 'CHECK_DISCHARGE_ALLOWS_REQUEST',
  CHECK_DISCHARGE_ALLOWS_SUCCESS: 'CHECK_DISCHARGE_ALLOWS_SUCCESS',
  CHECK_DISCHARGE_ALLOWS_FAILURE: 'CHECK_DISCHARGE_ALLOWS_FAILURE',
  CHECK_DISCHARGE_ALLOWS_LOADING: 'CHECK_DISCHARGE_ALLOWS_LOADING',
  CHECK_DISCHARGE_ALLOWS_RESET: 'CHECK_DISCHARGE_ALLOWS_RESET',

  //recheck discharge override status
  RECHECK_DISCHARGE_OVERRIDE_STATUS_REQUEST: 'RECHECK_DISCHARGE_OVERRIDE_STATUS_REQUEST',
  RECHECK_DISCHARGE_OVERRIDE_STATUS_SUCCESS: 'RECHECK_DISCHARGE_OVERRIDE_STATUS_SUCCESS',
  RECHECK_DISCHARGE_OVERRIDE_STATUS_FAILURE: 'RECHECK_DISCHARGE_OVERRIDE_STATUS_FAILURE',
  RECHECK_DISCHARGE_OVERRIDE_STATUS_LOADING: 'RECHECK_DISCHARGE_OVERRIDE_STATUS_LOADING',
  RECHECK_DISCHARGE_OVERRIDE_STATUS_RESET: 'RECHECK_DISCHARGE_OVERRIDE_STATUS_RESET',

  //approve recheck discharge
  APPROVE_RECHECK_DISCHARGE_REQUEST: 'APPROVE_RECHECK_DISCHARGE_REQUEST',
  APPROVE_RECHECK_DISCHARGE_SUCCESS: 'APPROVE_RECHECK_DISCHARGE_SUCCESS',
  APPROVE_RECHECK_DISCHARGE_FAILURE: 'APPROVE_RECHECK_DISCHARGE_FAILURE',
  APPROVE_RECHECK_DISCHARGE_LOADING: 'APPROVE_RECHECK_DISCHARGE_LOADING',
  APPROVE_RECHECK_DISCHARGE_RESET: 'APPROVE_RECHECK_DISCHARGE_RESET',

  //check pending docs alert
  CHECK_PENDING_DOCS_ALERT_REQUEST: 'CHECK_PENDING_DOCS_ALERT_REQUEST',
  CHECK_PENDING_DOCS_ALERT_SUCCESS: 'CHECK_PENDING_DOCS_ALERT_SUCCESS',
  CHECK_PENDING_DOCS_ALERT_FAILURE: 'CHECK_PENDING_DOCS_ALERT_FAILURE',
  CHECK_PENDING_DOCS_ALERT_RESET: 'CHECK_PENDING_DOCS_ALERT_RESET',

  // new sign documents
  NEW_DOCUMENT_SIGN_REQUEST: 'NEW_DOCUMENT_SIGN_REQUEST',
  NEW_DOCUMENT_SIGN_LOADING: 'NEW_DOCUMENT_SIGN_LOADING',
  NEW_DOCUMENT_SIGN_SUCCESS: 'NEW_DOCUMENT_SIGN_SUCCESS',
  NEW_DOCUMENT_SIGN_FAILURE: 'NEW_DOCUMENT_SIGN_FAILURE',
  NEW_DOCUMENT_SIGN_RESET: '  NEW_DOCUMENT_SIGN_RESET',

  UNDO_DOCUMENT_SIGN_REQUEST: 'UNDO_DOCUMENT_SIGN_REQUEST',
  UNDO_DOCUMENT_SIGN_LOADING: 'UNDO_DOCUMENT_SIGN_LOADING',
  UNDO_DOCUMENT_SIGN_SUCCESS: 'UNDO_DOCUMENT_SIGN_SUCCESS',
  UNDO_DOCUMENT_SIGN_FAILURE: 'UNDO_DOCUMENT_SIGN_FAILURE',
  UNDO_DOCUMENT_SIGN_RESET: '  UNDO_DOCUMENT_SIGN_RESET',

  // get due document setting
  REQUEST_DUE_DOCUMENT_SETTING_REQUEST: 'REQUEST_DUE_DOCUMENT_SETTING_REQUEST',
  REQUEST_DUE_DOCUMENT_SETTING_SUCCESS: 'REQUEST_DUE_DOCUMENT_SETTING_SUCCESS',
  REQUEST_DUE_DOCUMENT_SETTING_FAILURE: 'REQUEST_DUE_DOCUMENT_SETTING_FAILURE',
  REQUEST_DUE_DOCUMENT_SETTING_RESET: 'REQUEST_DUE_DOCUMENT_SETTING_RESET',
  REQUEST_DUE_DOCUMENT_SETTING_LOADING: 'REQUEST_DUE_DOCUMENT_SETTING_LOADING',

  //get therapist info
  GET_THERAPIST_INFO_REQUEST: 'GET_THERAPIST_INFO_REQUEST',
  GET_THERAPIST_INFO_SUCCESS: 'GET_THERAPIST_INFO_SUCCESS',
  GET_THERAPIST_INFO_FAILURE: 'GET_THERAPIST_INFO_FAILURE',
  GET_THERAPIST_INFO_RESET: 'GET_THERAPIST_INFO_RESET',
  GET_THERAPIST_INFO_LOADING: 'GET_THERAPIST_INFO_LOADING',

  //sign on behalf

  ADD_SIGN_ON_BEHALF_REQUEST: 'ADD_SIGN_ON_BEHALF_REQUEST',
  ADD_SIGN_ON_BEHALF_SUCCESS: 'ADD_SIGN_ON_BEHALF_SUCCESS',
  ADD_SIGN_ON_BEHALF_FAILURE: 'ADD_SIGN_ON_BEHALF_FAILURE',
  ADD_SIGN_ON_BEHALF_LOADING: 'ADD_SIGN_ON_BEHALF_LOADING',
  ADD_SIGN_ON_BEHALF_RESET: 'ADD_SIGN_ON_BEHALF_RESET',

  // hold a daily note from billing / include it back (BOPS-102)
  HOLD_DAILY_NOTE_FROM_BILLING_REQUEST: 'HOLD_DAILY_NOTE_FROM_BILLING_REQUEST',
  HOLD_DAILY_NOTE_FROM_BILLING_SUCCESS: 'HOLD_DAILY_NOTE_FROM_BILLING_SUCCESS',
  HOLD_DAILY_NOTE_FROM_BILLING_FAILURE: 'HOLD_DAILY_NOTE_FROM_BILLING_FAILURE',
  HOLD_DAILY_NOTE_FROM_BILLING_LOADING: 'HOLD_DAILY_NOTE_FROM_BILLING_LOADING',
  HOLD_DAILY_NOTE_FROM_BILLING_RESET: 'HOLD_DAILY_NOTE_FROM_BILLING_RESET',
};

export const dailySessionNotes = {
  GET_PATIENT_DAILY_SESSION_REQUEST: 'GET_PATIENT_DAILY_SESSION_REQUEST',
  GET_PATIENT_DAILY_SESSION_SUCCESS: 'GET_PATIENT_DAILY_SESSION_SUCCESS',
  GET_PATIENT_DAILY_SESSION_FAILURE: 'GET_PATIENT_DAILY_SESSION_FAILURE',
  GET_PATIENT_DAILY_SESSION_LOADING: 'GET_PATIENT_DAILY_SESSION_LOADING',
  RESET_PATIENT_DAILY_SESSION: 'RESET_PATIENT_DAILY_SESSION',
  GET_OTHER_PATIENT_DAILY_SESSION_REQUEST: 'GET_OTHER_PATIENT_DAILY_SESSION_REQUEST',
  GET_OTHER_PATIENT_DAILY_SESSION_SUCCESS: 'GET_OTHER_PATIENT_DAILY_SESSION_SUCCESS',
  GET_OTHER_PATIENT_DAILY_SESSION_FAILURE: 'GET_OTHER_PATIENT_DAILY_SESSION_FAILURE',
  GET_OTHER_PATIENT_DAILY_SESSION_LOADING: 'GET_OTHER_PATIENT_DAILY_SESSION_LOADING',
  RESET_OTHER_PATIENT_DAILY_SESSION: 'RESET_OTHER_PATIENT_DAILY_SESSION',
  PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_REQUEST:
    'PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_REQUEST',
  PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_SUCCESS:
    'PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_SUCCESS',
  PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_FAILURE:
    'PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_FAILURE',
  SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_LOADING:
    'PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_LOADING',
  RESET_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION: 'RESET_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION',
  GET_PATIENT_INFO_DAILY_SESSION_REQUEST: 'GET_PATIENT_INFO_DAILY_SESSION_REQUEST',
  GET_PATIENT_INFO_DAILY_SESSION_SUCCESS: 'GET_PATIENT_INFO_DAILY_SESSION_SUCCESS',
  GET_PATIENT_INFO_DAILY_SESSION_FAILURE: 'GET_PATIENT_INFO_DAILY_SESSION_FAILURE',
  GET_PATIENT_INFO_DAILY_SESSION_LOADING: 'GET_PATIENT_INFO_DAILY_SESSION_LOADING',
  GET_DAILY_SESSION_NOTES_REQUEST: 'GET_DAILY_SESSION_NOTES_REQUEST',
  GET_DAILY_SESSION_NOTES_SUCCESS: 'GET_DAILY_SESSION_NOTES_SUCCESS',
  GET_DAILY_SESSION_NOTES_FAILURE: 'GET_DAILY_SESSION_NOTES_FAILURE',
  GET_DAILY_SESSION_NOTES_LOADING: 'GET_DAILY_SESSION_NOTES_LOADING',
  GET_DAILY_SESSION_NOTES_RESET: 'GET_DAILY_SESSION_NOTES_RESET',
  UPDATE_DAILY_SESSION_NOTES_REQUEST: 'UPDATE_DAILY_SESSION_NOTES_REQUEST',
  UPDATE_DAILY_SESSION_NOTES_SUCCESS: 'UPDATE_DAILY_SESSION_NOTES_SUCCESS',
  UPDATE_DAILY_SESSION_NOTES_FAILURE: 'UPDATE_DAILY_SESSION_NOTES_FAILURE',
  RESET_UPDATE_DAILY_SESSION_NOTES: 'RESET_UPDATE_DAILY_SESSION_NOTES',
  REQUEST_GET_NOTE_TEMPLATE: 'REQUEST_GET_NOTE_TEMPLATE',
  SUCCESS_GET_NOTE_TEMPLATE: 'SUCCESS_GET_NOTE_TEMPLATE',
  FAILURE_GET_NOTE_TEMPLATE: 'FAILURE_GET_NOTE_TEMPLATE',
  LOADING_GET_NOTE_TEMPLATE: 'LOADING_GET_NOTE_TEMPLATE',
  RESET_GET_NOTE_TEMPLATE: 'RESET_GET_NOTE_TEMPLATE',
  REQUEST_SUBMIT_E_SIGN: 'REQUEST_SUBMIT_E_SIGN',
  SUCCESS_SUBMIT_E_SIGN: 'SUCCESS_SUBMIT_E_SIGN',
  FAILURE_SUBMIT_E_SIGN: 'FAILURE_SUBMIT_E_SIGN',
  RESET_SUBMIT_E_SIGN: 'RESET_SUBMIT_E_SIGN',
  LOADING_SUBMIT_E_SIGN: 'LOADING_SUBMIT_E_SIGN',

  GET_PATIENT_INFO_V2_DAILY_SESSION_REQUEST: 'GET_PATIENT_INFO_V2_DAILY_SESSION_REQUEST',
  GET_PATIENT_INFO_V2_DAILY_SESSION_SUCCESS: 'GET_PATIENT_INFO_V2_DAILY_SESSION_SUCCESS',
  GET_PATIENT_INFO_V2_DAILY_SESSION_FAILURE: 'GET_PATIENT_INFO_V2_DAILY_SESSION_FAILURE',
  GET_PATIENT_INFO_V2_DAILY_SESSION_LOADING: 'GET_PATIENT_INFO_V2_DAILY_SESSION_LOADING',

  GET_DAILY_NOTES_PRINT_STATUS_REQUEST: 'GET_DAILY_NOTES_PRINT_STATUS_REQUEST',
  GET_DAILY_NOTES_PRINT_STATUS_SUCCESS: 'GET_DAILY_NOTES_PRINT_STATUS_SUCCESS',
  GET_DAILY_NOTES_PRINT_STATUS_FAILURE: 'GET_DAILY_NOTES_PRINT_STATUS_FAILURE',
  GET_DAILY_NOTES_PRINT_STATUS_LOADING: 'GET_DAILY_NOTES_PRINT_STATUS_LOADING',
  RESET_DAILY_NOTES_PRINT_STATUS: 'RESET_DAILY_NOTES_PRINT_STATUS',

  DELETE_DAILY_SESSION_NOTE_REQUEST: 'DELETE_DAILY_SESSION_NOTE_REQUEST',
  DELETE_DAILY_SESSION_NOTE_SUCCESS: 'DELETE_DAILY_SESSION_NOTE_SUCCESS',
  DELETE_DAILY_SESSION_NOTE_FAILURE: 'DELETE_DAILY_SESSION_NOTE_FAILURE',
  DELETE_DAILY_SESSION_NOTE_LOADING: 'DELETE_DAILY_SESSION_NOTE_LOADING',
  DELETE_DAILY_SESSION_NOTE_RESET: 'DELETE_DAILY_SESSION_NOTE_RESET',
  ARCHIVE_DAILY_SESSION_NOTE_REQUEST: 'ARCHIVE_DAILY_SESSION_NOTE_REQUEST',
  ARCHIVE_DAILY_SESSION_NOTE_SUCCESS: 'ARCHIVE_DAILY_SESSION_NOTE_SUCCESS',
  ARCHIVE_DAILY_SESSION_NOTE_FAILURE: 'ARCHIVE_DAILY_SESSION_NOTE_FAILURE',
  ARCHIVE_DAILY_SESSION_NOTE_LOADING: 'ARCHIVE_DAILY_SESSION_NOTE_LOADING',
  ARCHIVE_DAILY_SESSION_NOTE_RESET: 'ARCHIVE_DAILY_SESSION_NOTE_RESET',
  GET_ARCHIVED_DOCUMENTS_REQUEST: 'GET_ARCHIVED_DOCUMENTS_REQUEST',
  GET_ARCHIVED_DOCUMENTS_SUCCESS: 'GET_ARCHIVED_DOCUMENTS_SUCCESS',
  GET_ARCHIVED_DOCUMENTS_FAILURE: 'GET_ARCHIVED_DOCUMENTS_FAILURE',
  GET_ARCHIVED_DOCUMENTS_LOADING: 'GET_ARCHIVED_DOCUMENTS_LOADING',
  GET_ARCHIVED_DOCUMENTS_RESET: 'GET_ARCHIVED_DOCUMENTS_RESET',
};

export const patientDeleteTask = {
  DELETE_PATIENT_TASK_REQUEST: 'DELETE_PATIENT_TASK_REQUEST',
  DELETE_PATIENT_TASK_SUCCESS: 'DELETE_PATIENT_TASK_SUCCESS',
  DELETE_PATIENT_TASK_FAILURE: 'DELETE_PATIENT_TASK_FAILURE',
  DELETE_PATIENT_TASK_LOADER: 'DELETE_PATIENT_TASK_LOADER',
  RESET_DELETE_PATIENT_TASK: 'RESET_DELETE_PATIENT_TASK',
};

export const DashboardConstants = {
  //patient list
  GET_DASHBOARD_PATIENT_LIST_REQUEST: 'GET_DASHBOARD_PATIENT_LIST_REQUEST',
  GET_DASHBOARD_PATIENT_LIST_SUCCESS: 'GET_DASHBOARD_PATIENT_LIST_SUCCESS',
  GET_DASHBOARD_PATIENT_LIST_FAILURE: 'GET_DASHBOARD_PATIENT_LIST_FAILURE',
  GET_DASHBOARD_PATIENT_LIST_LOADER: 'GET_DASHBOARD_PATIENT_LIST_LOADER',

  //today patient list (v2)
  GET_TODAY_PATIENT_LIST_REQUEST: 'GET_TODAY_PATIENT_LIST_REQUEST',
  GET_TODAY_PATIENT_LIST_SUCCESS: 'GET_TODAY_PATIENT_LIST_SUCCESS',
  GET_TODAY_PATIENT_LIST_FAILURE: 'GET_TODAY_PATIENT_LIST_FAILURE',
  GET_TODAY_PATIENT_LIST_LOADER: 'GET_TODAY_PATIENT_LIST_LOADER',
  GET_TODAY_PATIENT_LIST_RESET: 'GET_TODAY_PATIENT_LIST_RESET',

  //document  management
  GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_REQUEST: 'GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_REQUEST',
  GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_SUCCESS: 'GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_SUCCESS',
  GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_FAILURE: 'GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_FAILURE',
  GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_LOADER: 'GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_LOADER',
  GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_RESET: 'GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_RESET',

  //other dashboard documents
  GET_OTHER_DASHBOARD_DOCUMENT_REQUEST: 'GET_OTHER_DASHBOARD_DOCUMENT_REQUEST',
  GET_OTHER_DASHBOARD_DOCUMENT_SUCCESS: 'GET_OTHER_DASHBOARD_DOCUMENT_SUCCESS',
  GET_OTHER_DASHBOARD_DOCUMENT_FAILURE: 'GET_OTHER_DASHBOARD_DOCUMENT_FAILURE',
  GET_OTHER_DASHBOARD_DOCUMENT_LOADER: 'GET_OTHER_DASHBOARD_DOCUMENT_LOADER',
  GET_OTHER_DASHBOARD_DOCUMENT_RESET: 'GET_OTHER_DASHBOARD_DOCUMENT_RESET',

  //other dashboard documents
  GET_MY_DASHBOARD_DOCUMENT_REQUEST: 'GET_MY_DASHBOARD_DOCUMENT_REQUEST',
  GET_MY_DASHBOARD_DOCUMENT_SUCCESS: 'GET_MY_DASHBOARD_DOCUMENT_SUCCESS',
  GET_MY_DASHBOARD_DOCUMENT_FAILURE: 'GET_MY_DASHBOARD_DOCUMENT_FAILURE',
  GET_MY_DASHBOARD_DOCUMENT_LOADER: 'GET_MY_DASHBOARD_DOCUMENT_LOADER',
  GET_MY_DASHBOARD_DOCUMENT_RESET: 'GET_MY_DASHBOARD_DOCUMENT_RESET',

  //document  management csv
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_REQUEST:
    'GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_REQUEST',
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_SUCCESS:
    'GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_SUCCESS',
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_FAILURE:
    'GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_FAILURE',
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_LOADER:
    'GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_LOADER',
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_RESET: 'GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_RESET',

  //overview of task

  GET_DASHBOARD_OVERVIEW_REQUEST: 'GET_DASHBOARD_OVERVIEW_REQUEST',
  GET_DASHBOARD_OVERVIEW_SUCCESS: 'GET_DASHBOARD_OVERVIEW_SUCCESS',
  GET_DASHBOARD_OVERVIEW_FAILURE: 'GET_DASHBOARD_OVERVIEW_FAILURE',
  GET_DASHBOARD_OVERVIEW_LOADER: 'GET_DASHBOARD_OVERVIEW_LOADER',
  GET_DASHBOARD_THERAPY_REQUEST: 'GET_DASHBOARD_THERAPY_REQUEST',
  GET_DASHBOARD_THERAPY_SUCCESS: 'GET_DASHBOARD_THERAPY_SUCCESS',
  GET_DASHBOARD_THERAPY_FAILURE: 'GET_DASHBOARD_THERAPY_FAILURE',
  GET_DASHBOARD_THERAPY_LOADER: 'GET_DASHBOARD_THERAPY_LOADER',
  GET_DASHBOARD_DOCUMENTATION_REQUEST: 'GET_DASHBOARD_DOCUMENTATION_REQUEST',
  GET_DASHBOARD_DOCUMENTATION_SUCCESS: 'GET_DASHBOARD_DOCUMENTATION_SUCCESS',
  GET_DASHBOARD_DOCUMENTATION_FAILURE: 'GET_DASHBOARD_DOCUMENTATION_FAILURE',
  GET_DASHBOARD_DOCUMENTATION_LOADER: 'GET_DASHBOARD_DOCUMENTATION_LOADER',

  //get time in
  GET_DASHBOARD_TIME_IN_REQUEST: 'GET_DASHBOARD_TIME_IN_REQUEST',
  GET_DASHBOARD_TIME_IN_SUCCESS: 'GET_DASHBOARD_TIME_IN_SUCCESS',
  GET_DASHBOARD_TIME_IN_FAILURE: 'GET_DASHBOARD_TIME_IN_FAILURE',
  GET_DASHBOARD_TIME_IN_LOADER: 'GET_DASHBOARD_TIME_IN_LOADER',
  GET_DASHBOARD_TIME_IN_RESET: 'GET_DASHBOARD_TIME_IN_RESET',
  RESET_HARD_CLOCK_IN: 'RESET_HARD_CLOCK_IN',

  //post check out
  POST_DASHBOARD_CHECKOUT_REQUEST: 'POST_DASHBOARD_CHECKOUT_REQUEST',
  POST_DASHBOARD_CHECKOUT_SUCCESS: 'POST_DASHBOARD_CHECKOUT_SUCCESS',
  POST_DASHBOARD_CHECKOUT_FAILURE: 'POST_DASHBOARD_CHECKOUT_FAILURE',
  POST_DASHBOARD_CHECKOUT_LOADER: 'POST_DASHBOARD_CHECKOUT_LOADER',
  POST_DASHBOARD_CHECKOUT_RESET: 'POST_DASHBOARD_CHECKOUT_RESET',
  POST_DASHBOARD_CHECKOUT_RESET_LOGOUT: 'POST_DASHBOARD_CHECKOUT_RESET_LOGOUT',
  CLOCK_ACTION: 'CLOCK_ACTION',
  POST_CHECKOUT_ACTION_RESET: 'POST_CHECKOUT_ACTION_RESET',

  //get patient details
  GET_DASHBOARD_PATIENT_DETAILS_REQUEST: 'GET_DASHBOARD_PATIENT_DETAILS_REQUEST',
  GET_DASHBOARD_PATIENT_DETAILS_SUCCESS: 'GET_DASHBOARD_PATIENT_DETAILS_SUCCESS',
  GET_DASHBOARD_PATIENT_DETAILS_FAILURE: 'GET_DASHBOARD_PATIENT_DETAILS_FAILURE',
  GET_DASHBOARD_PATIENT_DETAILS_LOADER: 'GET_DASHBOARD_PATIENT_DETAILS_LOADER',
  GET_DASHBOARD_PATIENT_DETAILS_RESET: 'GET_DASHBOARD_PATIENT_DETAILS_RESET',

  //get pto latest update

  GET_DASHBOARD_PTO_UPDATE_REQUEST: 'GET_DASHBOARD_PTO_UPDATE_REQUEST',
  GET_DASHBOARD_PTO_UPDATE_SUCCESS: 'GET_DASHBOARD_PTO_UPDATE_SUCCESS',
  GET_DASHBOARD_PTO_UPDATE_FAILURE: 'GET_DASHBOARD_PTO_UPDATE_FAILURE',
  GET_DASHBOARD_PTO_UPDATE_LOADER: 'GET_DASHBOARD_PTO_UPDATE_LOADER',
  GET_DASHBOARD_PTO_UPDATE_RESET: 'GET_DASHBOARD_PTO_UPDATE_RESET',

  //get intervention group

  GET_INTERVENTION_GROUP_REQUEST: 'GET_INTERVENTION_GROUP_REQUEST',
  GET_INTERVENTION_GROUP_SUCCESS: 'GET_INTERVENTION_GROUP_SUCCESS',
  GET_INTERVENTION_GROUP_FAILURE: 'GET_INTERVENTION_GROUP_FAILURE',
  GET_INTERVENTION_GROUP_LOADER: 'GET_INTERVENTION_GROUP_LOADER',
  GET_INTERVENTION_GROUP_RESET: 'GET_INTERVENTION_GROUP_RESET',

  //get game by intervention

  GET_GAME_BY_INTERVENTION_REQUEST: 'GET_GAME_BY_INTERVENTION_REQUEST',
  GET_GAME_BY_INTERVENTION_SUCCESS: 'GET_GAME_BY_INTERVENTION_SUCCESS',
  GET_GAME_BY_INTERVENTION_FAILURE: 'GET_GAME_BY_INTERVENTION_FAILURE',
  GET_GAME_BY_INTERVENTION_LOADER: 'GET_GAME_BY_INTERVENTION_LOADER',
  GET_GAME_BY_INTERVENTION_RESET: 'GET_GAME_BY_INTERVENTION_RESET',

  //auto clock out call
  GET_AUTO_CLOCK_OUT_CALL_REQUEST: 'GET_AUTO_CLOCK_OUT_CALL_REQUEST',
  GET_AUTO_CLOCK_OUT_CALL_SUCCESS: 'GET_AUTO_CLOCK_OUT_CALL_SUCCESS',
  GET_AUTO_CLOCK_OUT_CALL_FAILURE: 'GET_AUTO_CLOCK_OUT_CALL_FAILURE',

  // loggen in therapist's daily updates

  GET_THERAPIST_DAILY_UPDATES_REQUEST: 'GET_THERAPIST_DAILY_UPDATES_REQUEST',
  GET_THERAPIST_DAILY_UPDATES_SUCCESS: 'GET_THERAPIST_DAILY_UPDATES_SUCCESS',
  GET_THERAPIST_DAILY_UPDATES_FAILURE: 'GET_THERAPIST_DAILY_UPDATES_FAILURE',
  GET_THERAPIST_DAILY_UPDATES_RESET: 'GET_THERAPIST_DAILY_UPDATES_RESET',

  GET_DASHBOARD_SUPERVISOR_EDIT_REQUEST: 'GET_DASHBOARD_SUPERVISOR_EDIT_REQUEST',
  GET_DASHBOARD_SUPERVISOR_EDIT_SUCCESS: 'GET_DASHBOARD_SUPERVISOR_EDIT_SUCCESS',
  GET_DASHBOARD_SUPERVISOR_EDIT_FAILURE: 'GET_DASHBOARD_SUPERVISOR_EDIT_FAILURE',
  GET_DASHBOARD_SUPERVISOR_EDIT_RESET: 'GET_DASHBOARD_SUPERVISOR_EDIT_RESET',

  CO_SIGNATURE_REVIEW_REQUEST: 'CO_SIGNATURE_REVIEW_REQUEST',
  CO_SIGNATURE_REVIEW_SUCCESS: 'CO_SIGNATURE_REVIEW_SUCCESS',
  CO_SIGNATURE_REVIEW_FAILURE: 'CO_SIGNATURE_REVIEW_FAILURE',
  CO_SIGNATURE_REVIEW_RESET: 'CO_SIGNATURE_REVIEW_RESET',
  CO_SIGNATURE_REVIEW_LOADING: 'CO_SIGNATURE_REVIEW_LOADING',

  // therapist bulk signature

  APPLY_THERAPIST_BULK_SIGNATURE_REQUEST: 'APPLY_THERAPIST_BULK_SIGNATURE_REQUEST',
  APPLY_THERAPIST_BULK_SIGNATURE_SUCCESS: 'APPLY_THERAPIST_BULK_SIGNATURE_SUCCESS',
  APPLY_THERAPIST_BULK_SIGNATURE_FAILURE: 'APPLY_THERAPIST_BULK_SIGNATURE_FAILURE',
  APPLY_THERAPIST_BULK_SIGNATURE_LOADING: 'APPLY_THERAPIST_BULK_SIGNATURE_LOADING',
  APPLY_THERAPIST_BULK_SIGNATURE_RESET: 'APPLY_THERAPIST_BULK_SIGNATURE_RESET',

  //get dsn Summary
  GET_DSN_SUMMARY_REQUEST: 'GET_DSN_SUMMARY_REQUEST',
  GET_DSN_SUMMARY_SUCCESS: 'GET_DSN_SUMMARY_SUCCESS',
  GET_DSN_SUMMARY_FAILURE: 'GET_DSN_SUMMARY_FAILURE',
  GET_DSN_SUMMARY_LOADING: 'GET_DSN_SUMMARY_LOADING',
  GET_DSN_SUMMARY_RESET: 'GET_DSN_SUMMARY_RESET',
};

export const commonActions = {
  STORE_SUBDOMAIN_REDUX: 'STORE_SUBDOMAIN_REDUX',
  RESET_SUBDOMAIN_REDUX: 'RESET_SUBDOMAIN_REDUX',
};

export const schedulingTask = {
  //create note
  CREATE_TASK_NOTE_SCHEDULING_REQUEST: 'CREATE_TASK_NOTE_SCHEDULING_REQUEST',
  CREATE_TASK_NOTE_SCHEDULING_SUCCESS: 'CREATE_TASK_NOTE_SCHEDULING_SUCCESS',
  CREATE_TASK_NOTE_SCHEDULING_FAILURE: 'CREATE_TASK_NOTE_SCHEDULING_FAILURE',
  CREATE_TASK_NOTE_SCHEDULING_LOADING: 'CREATE_TASK_NOTE_SCHEDULING_LOADING',
  CREATE_TASK_NOTE_SCHEDULING_RESET: 'CREATE_TASK_NOTE_SCHEDULING_RESET',

  // GET NOTE
  GET_TASK_NOTE_SCHEDULING_REQUEST: 'GET_TASK_NOTE_SCHEDULING_REQUEST',
  GET_TASK_NOTE_SCHEDULING_SUCCESS: 'GET_TASK_NOTE_SCHEDULING_SUCCESS',
  GET_TASK_NOTE_SCHEDULING_FAILURE: 'GET_TASK_NOTE_SCHEDULING_FAILURE',
  GET_TASK_NOTE_SCHEDULING_LOADING: 'GET_TASK_NOTE_SCHEDULING_LOADING',
  GET_TASK_NOTE_SCHEDULING_RESET: 'GET_TASK_NOTE_SCHEDULING_RESET',

  DELETE_TASK_NOTE_SCHEDULING_REQUEST: 'DELETE_TASK_NOTE_SCHEDULING_REQUEST',
  DELETE_TASK_NOTE_SCHEDULING_SUCCESS: 'DELETE_TASK_NOTE_SCHEDULING_SUCCESS',
  DELETE_TASK_NOTE_SCHEDULING_FAILURE: 'DELETE_TASK_NOTE_SCHEDULING_FAILURE',
  DELETE_TASK_NOTE_SCHEDULING_LOADING: 'DELETE_TASK_NOTE_SCHEDULING_LOADING',
  DELETE_TASK_NOTE_SCHEDULING_RESET: 'DELETE_TASK_NOTE_SCHEDULING_RESET',
};

export const copyTextBankActions = {
  REQUEST_SEARCH_CPT_CODES: 'REQUEST_SEARCH_CPT_CODES',
  SUCCESS_SEARCH_CPT_CODES: 'SUCCESS_SEARCH_CPT_CODES',
  FAILURE_SEARCH_CPT_CODES: 'FAILURE_SEARCH_CPT_CODES',
};

export const PhysicianActions = {
  //GET all signature list

  REQUEST_GET_ALL_PHYSICIAN_DOCUMENTS: 'REQUEST_GET_ALL_PHYSICIAN_DOCUMENTS',
  SUCCESS_GET_ALL_PHYSICIAN_DOCUMENTS: 'SUCCESS_GET_ALL_PHYSICIAN_DOCUMENTS',
  FAILURE_GET_ALL_PHYSICIAN_DOCUMENTS: 'FAILURE_GET_ALL_PHYSICIAN_DOCUMENTS',
  LOADING_GET_ALL_PHYSICIAN_DOCUMENTS: 'LOADING_GET_ALL_PHYSICIAN_DOCUMENTS',
  RESET_GET_ALL_PHYSICIAN_DOCUMENTS: 'RESET_GET_ALL_PHYSICIAN_DOCUMENTS',

  //GET all completed signature list

  REQUEST_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS: 'REQUEST_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS',
  SUCCESS_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS: 'SUCCESS_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS',
  FAILURE_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS: 'FAILURE_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS',
  LOADING_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS: 'LOADING_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS',
  RESET_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS: 'RESET_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS',

  // get all facilities
  GET_ALL_FACILITY_REQUEST: 'GET_ALL_FACILITY_REQUEST',
  GET_ALL_FACILITY_SUCCESS: 'GET_ALL_FACILITY_SUCCESS',
  GET_ALL_FACILITY_LOADER: 'GET_ALL_FACILITY_LOADER',
  GET_ALL_FACILITY_FAILURE: 'GET_ALL_FACILITY_FAILURE',
  GET_ALL_FACILITY_RESET: 'GET_ALL_FACILITY_RESET',

  //get All patient by entriseprise

  GET_ALL_PATIENT_BY_ENTERPRISE_REQUEST: 'GET_ALL_PATIENT_BY_ENTERPRISE_REQUEST',
  GET_ALL_PATIENT_BY_ENTERPRISE_SUCCESS: 'GET_ALL_PATIENT_BY_ENTERPRISE_SUCCESS',
  GET_ALL_PATIENT_BY_ENTERPRISE_FAILURE: 'GET_ALL_PATIENT_BY_ENTERPRISE_FAILURE',
  GET_ALL_PATIENT_BY_ENTERPRISE_RESET: 'GET_ALL_PATIENT_BY_ENTERPRISE_RESET',
  GET_ALL_PATIENT_BY_ENTERPRISE_LOADING: 'GET_ALL_PATIENT_BY_ENTERPRISE_LOADING',

  UPDATE_DOCUMENT_STATUSES_REQUEST: 'UPDATE_DOCUMENT_STATUSES_REQUEST',
  UPDATE_DOCUMENT_STATUSES_LOADING: 'UPDATE_DOCUMENT_STATUSES_LOADING',
  UPDATE_DOCUMENT_STATUSES_SUCCESS: 'UPDATE_DOCUMENT_STATUSES_SUCCESS',
  UPDATE_DOCUMENT_STATUSES_FAILURE: 'UPDATE_DOCUMENT_STATUSES_FAILURE',
  UPDATE_DOCUMENT_STATUSES_RESET: 'UPDATE_DOCUMENT_STATUSES_RESET',
};

export const PatientPayersActions = {
  // Create payer from patient profile
  CREATE_PATIENT_PAYER_REQUEST: 'CREATE_PATIENT_PAYER_REQUEST',
  CREATE_PATIENT_PAYER_SUCCESS: 'CREATE_PATIENT_PAYER_SUCCESS',
  CREATE_PATIENT_PAYER_FAILURE: 'CREATE_PATIENT_PAYER_FAILURE',
  CREATE_PATIENT_PAYER_RESET: 'CREATE_PATIENT_PAYER_RESET',

  // Get All patient payer
  GET_ALL_PATIENT_PAYER_REQUEST: 'GET_ALL_PATIENT_PAYER_REQUEST',
  GET_ALL_PATIENT_PAYER_SUCCESS: 'GET_ALL_PATIENT_PAYER_SUCCESS',
  GET_ALL_PATIENT_PAYER_FAILURE: 'GET_ALL_PATIENT_PAYER_FAILURE',
  GET_ALL_PATIENT_PAYER_RESET: 'GET_ALL_PATIENT_PAYER_RESET',

  // Validate payer edit against MDS assessment ARDs
  VALIDATE_MDS_PAYER_REQUEST: 'VALIDATE_MDS_PAYER_REQUEST',
  VALIDATE_MDS_PAYER_SUCCESS: 'VALIDATE_MDS_PAYER_SUCCESS',
  VALIDATE_MDS_PAYER_FAILURE: 'VALIDATE_MDS_PAYER_FAILURE',
  VALIDATE_MDS_PAYER_LOADING: 'VALIDATE_MDS_PAYER_LOADING',
  VALIDATE_MDS_PAYER_RESET: 'VALIDATE_MDS_PAYER_RESET',

  // Update patient payer details

  UPDATE_PATIENT_PAYER_REQUEST: 'UPDATE_PATIENT_PAYER_REQUEST',
  UPDATE_PATIENT_PAYER_SUCCESS: 'UPDATE_PATIENT_PAYER_SUCCESS',
  UPDATE_PATIENT_PAYER_FAILURE: 'UPDATE_PATIENT_PAYER_FAILURE',
  UPDATE_PATIENT_PAYER_RESET: 'UPDATE_PATIENT_PAYER_RESET',

  // Payer options for the payer-history filter dropdown
  GET_PAYER_OPTIONS_REQUEST: 'GET_PAYER_OPTIONS_REQUEST',
  GET_PAYER_OPTIONS_SUCCESS: 'GET_PAYER_OPTIONS_SUCCESS',
  GET_PAYER_OPTIONS_FAILURE: 'GET_PAYER_OPTIONS_FAILURE',
  GET_PAYER_OPTIONS_LOADING: 'GET_PAYER_OPTIONS_LOADING',
  GET_PAYER_OPTIONS_RESET: 'GET_PAYER_OPTIONS_RESET',

  // THIN-8401: every payer date range of a patient, to bound the Add Payer date pickers
  GET_PAYER_DATE_RANGES_REQUEST: 'GET_PAYER_DATE_RANGES_REQUEST',
  GET_PAYER_DATE_RANGES_SUCCESS: 'GET_PAYER_DATE_RANGES_SUCCESS',
  GET_PAYER_DATE_RANGES_FAILURE: 'GET_PAYER_DATE_RANGES_FAILURE',
  GET_PAYER_DATE_RANGES_LOADING: 'GET_PAYER_DATE_RANGES_LOADING',
  GET_PAYER_DATE_RANGES_RESET: 'GET_PAYER_DATE_RANGES_RESET',

  // Payer history list for the payer-history drawer
  GET_PAYER_HISTORY_REQUEST: 'GET_PAYER_HISTORY_REQUEST',
  GET_PAYER_HISTORY_SUCCESS: 'GET_PAYER_HISTORY_SUCCESS',
  GET_PAYER_HISTORY_FAILURE: 'GET_PAYER_HISTORY_FAILURE',
  GET_PAYER_HISTORY_LOADING: 'GET_PAYER_HISTORY_LOADING',
  GET_PAYER_HISTORY_RESET: 'GET_PAYER_HISTORY_RESET',
};

export const mdsDashboardActions = {
  SET_MDS_WORKSHEET_DIRTY: 'SET_MDS_WORKSHEET_DIRTY',
};

//  THIN-7681 signature validation — signing-PIN status / setup / reset.
export const SigningPinConstants = {
  GET_SIGNING_PIN_STATUS_REQUEST: 'GET_SIGNING_PIN_STATUS_REQUEST',
  GET_SIGNING_PIN_STATUS_SUCCESS: 'GET_SIGNING_PIN_STATUS_SUCCESS',
  GET_SIGNING_PIN_STATUS_FAILURE: 'GET_SIGNING_PIN_STATUS_FAILURE',
  GET_SIGNING_PIN_STATUS_LOADING: 'GET_SIGNING_PIN_STATUS_LOADING',
  SETUP_SIGNING_PIN_REQUEST: 'SETUP_SIGNING_PIN_REQUEST',
  SETUP_SIGNING_PIN_SUCCESS: 'SETUP_SIGNING_PIN_SUCCESS',
  SETUP_SIGNING_PIN_FAILURE: 'SETUP_SIGNING_PIN_FAILURE',
  SETUP_SIGNING_PIN_LOADING: 'SETUP_SIGNING_PIN_LOADING',
  RESET_SIGNING_PIN_REQUEST: 'RESET_SIGNING_PIN_REQUEST',
  RESET_SIGNING_PIN_SUCCESS: 'RESET_SIGNING_PIN_SUCCESS',
  RESET_SIGNING_PIN_FAILURE: 'RESET_SIGNING_PIN_FAILURE',
  RESET_SIGNING_PIN_LOADING: 'RESET_SIGNING_PIN_LOADING',
  SIGNING_PIN_ACTION_RESET: 'SIGNING_PIN_ACTION_RESET',
};

//  RA-2027 quarterly CMS Payroll-Based Journal export (Report Downloads -> Labor). Deliberately
//  NOT in the redux-persist whitelist in store.ts: the SUCCESS payload carries the file's bytes,
//  and a stale PBJ blob surviving a refresh is not wanted.
export const pbjExportActions = {
  GET_PBJ_EXPORT_REQUEST: 'GET_PBJ_EXPORT_REQUEST',
  GET_PBJ_EXPORT_LOADING: 'GET_PBJ_EXPORT_LOADING',
  GET_PBJ_EXPORT_SUCCESS: 'GET_PBJ_EXPORT_SUCCESS',
  GET_PBJ_EXPORT_FAILURE: 'GET_PBJ_EXPORT_FAILURE',
  GET_PBJ_EXPORT_RESET: 'GET_PBJ_EXPORT_RESET',
};

export const documentBundleActions = {
  REQUEST_GET_PAYER_FILTERS: 'REQUEST_GET_PAYER_FILTERS',
  SUCCESS_GET_PAYER_FILTERS: 'SUCCESS_GET_PAYER_FILTERS',
  FAILURE_GET_PAYER_FILTERS: 'FAILURE_GET_PAYER_FILTERS',
  LOADING_GET_PAYER_FILTERS: 'LOADING_GET_PAYER_FILTERS',
  RESET_GET_PAYER_FILTERS: 'RESET_GET_PAYER_FILTERS',

  REQUEST_GET_PATIENT_FILTERS: 'REQUEST_GET_PATIENT_FILTERS',
  SUCCESS_GET_PATIENT_FILTERS: 'SUCCESS_GET_PATIENT_FILTERS',
  FAILURE_GET_PATIENT_FILTERS: 'FAILURE_GET_PATIENT_FILTERS',
  LOADING_GET_PATIENT_FILTERS: 'LOADING_GET_PATIENT_FILTERS',
  RESET_GET_PATIENT_FILTERS: 'RESET_GET_PATIENT_FILTERS',

  REQUEST_GET_DOCUMENT_SUMMARY: 'REQUEST_GET_DOCUMENT_SUMMARY',
  SUCCESS_GET_DOCUMENT_SUMMARY: 'SUCCESS_GET_DOCUMENT_SUMMARY',
  FAILURE_GET_DOCUMENT_SUMMARY: 'FAILURE_GET_DOCUMENT_SUMMARY',
  LOADING_GET_DOCUMENT_SUMMARY: 'LOADING_GET_DOCUMENT_SUMMARY',
  RESET_GET_DOCUMENT_SUMMARY: 'RESET_GET_DOCUMENT_SUMMARY',

  REQUEST_GET_DOWNLOAD_JOBS: 'REQUEST_GET_DOWNLOAD_JOBS',
  SUCCESS_GET_DOWNLOAD_JOBS: 'SUCCESS_GET_DOWNLOAD_JOBS',
  FAILURE_GET_DOWNLOAD_JOBS: 'FAILURE_GET_DOWNLOAD_JOBS',
  LOADING_GET_DOWNLOAD_JOBS: 'LOADING_GET_DOWNLOAD_JOBS',
  RESET_GET_DOWNLOAD_JOBS: 'RESET_GET_DOWNLOAD_JOBS',

  REQUEST_SUBMIT_DOWNLOAD_JOB: 'REQUEST_SUBMIT_DOWNLOAD_JOB',
  SUCCESS_SUBMIT_DOWNLOAD_JOB: 'SUCCESS_SUBMIT_DOWNLOAD_JOB',
  FAILURE_SUBMIT_DOWNLOAD_JOB: 'FAILURE_SUBMIT_DOWNLOAD_JOB',
  LOADING_SUBMIT_DOWNLOAD_JOB: 'LOADING_SUBMIT_DOWNLOAD_JOB',
  RESET_SUBMIT_DOWNLOAD_JOB: 'RESET_SUBMIT_DOWNLOAD_JOB',

  REQUEST_GET_PRESIGNED_URL: 'REQUEST_GET_PRESIGNED_URL',
  SUCCESS_GET_PRESIGNED_URL: 'SUCCESS_GET_PRESIGNED_URL',
  FAILURE_GET_PRESIGNED_URL: 'FAILURE_GET_PRESIGNED_URL',
  LOADING_GET_PRESIGNED_URL: 'LOADING_GET_PRESIGNED_URL',
  RESET_GET_PRESIGNED_URL: 'RESET_GET_PRESIGNED_URL',

  REQUEST_GET_THERAPIST_FILTERS: 'REQUEST_GET_THERAPIST_FILTERS',
  SUCCESS_GET_THERAPIST_FILTERS: 'SUCCESS_GET_THERAPIST_FILTERS',
  FAILURE_GET_THERAPIST_FILTERS: 'FAILURE_GET_THERAPIST_FILTERS',
  LOADING_GET_THERAPIST_FILTERS: 'LOADING_GET_THERAPIST_FILTERS',
  RESET_GET_THERAPIST_FILTERS: 'RESET_GET_THERAPIST_FILTERS',

  REQUEST_SEARCH_PATIENTS: 'REQUEST_SEARCH_PATIENTS',
  SUCCESS_SEARCH_PATIENTS: 'SUCCESS_SEARCH_PATIENTS',
  FAILURE_SEARCH_PATIENTS: 'FAILURE_SEARCH_PATIENTS',
  LOADING_SEARCH_PATIENTS: 'LOADING_SEARCH_PATIENTS',
  RESET_SEARCH_PATIENTS: 'RESET_SEARCH_PATIENTS',

  REQUEST_GET_PATIENT_INTERVALS: 'REQUEST_GET_PATIENT_INTERVALS',
  SUCCESS_GET_PATIENT_INTERVALS: 'SUCCESS_GET_PATIENT_INTERVALS',
  FAILURE_GET_PATIENT_INTERVALS: 'FAILURE_GET_PATIENT_INTERVALS',
  LOADING_GET_PATIENT_INTERVALS: 'LOADING_GET_PATIENT_INTERVALS',
  RESET_GET_PATIENT_INTERVALS: 'RESET_GET_PATIENT_INTERVALS',

  REQUEST_GET_PATIENT_DOCUMENTS: 'REQUEST_GET_PATIENT_DOCUMENTS',
  SUCCESS_GET_PATIENT_DOCUMENTS: 'SUCCESS_GET_PATIENT_DOCUMENTS',
  FAILURE_GET_PATIENT_DOCUMENTS: 'FAILURE_GET_PATIENT_DOCUMENTS',
  LOADING_GET_PATIENT_DOCUMENTS: 'LOADING_GET_PATIENT_DOCUMENTS',
  RESET_GET_PATIENT_DOCUMENTS: 'RESET_GET_PATIENT_DOCUMENTS',

  CANCEL_DOWNLOAD_JOB: 'CANCEL_DOWNLOAD_JOB',
  ADD_DOWNLOAD_JOB: 'ADD_DOWNLOAD_JOB',
};
